<template>
  <div class="modal-overlay">
    <div class="modal-container">
      <!-- Cabeçalho -->
      <div class="modal-header">
        <h5>Renovar Matrícula</h5>
        <button class="btn-close" @click="cancel"></button>
      </div>

      <!-- Corpo -->
      <div class="modal-body">
        <!-- Dados do Plano Atual -->
        <h6 class="section-title">Dados do Plano Atual</h6>
        <div v-if="planoAtual.turmas?.length" class="mb-3">
          <label>Turmas atuais (origem):</label>
          <ul><li v-for="(t, i) in planoAtual.turmas" :key="i">{{ t.turma_completa }}</li></ul>
        </div>
        <div class="row mt-3 mb-3">
          <div class="col">
            <label class="form-label">Categoria:</label>
            <input type="text" :value="planoAtual.categoria" class="form-control" disabled />
          </div>
          <div class="col">
            <label class="form-label">Tipo de Plano:</label>
            <input type="text" :value="planoAtual.tipo_plano" class="form-control" disabled />
          </div>
          <div class="col">
            <label class="form-label">Aulas por Semana:</label>
            <input type="text" :value="planoAtual.aulas_semana" class="form-control" disabled />
          </div>
          <div class="col">
            <label class="form-label">Qtd. de Parcelas:</label>
            <input type="text" :value="planoAtual.quantidade_parcelas" class="form-control" disabled />
          </div>
        </div>
        <div class="row mb-4">
          <div class="col">
            <label class="form-label">Nível:</label>
            <input type="text" :value="planoAtual.nivel" class="form-control" disabled />
          </div>
          <div class="col">
            <label class="form-label">Início da Vigência:</label>
            <input type="date" :value="planoAtual.inicio_vigencia" class="form-control" disabled />
          </div>
          <div class="col">
            <label class="form-label">Término da Vigência:</label>
            <input type="date" :value="planoAtual.termino_vigencia" class="form-control" disabled />
          </div>
        <!-- Consentimento de uso de imagem -->
        <div class="row mt-3 mb-3">
          <div class="col-md-6">
            <label for="direitoImagemNovo" class="form-label">
              Concorda com o uso da imagem do aluno pela escola? <span class="required">*</span>
            </label>
            <select
              id="direitoImagemNovo"
              v-model="editablePlano.direito_imagem"
              class="form-control"
              required
            >
              <option value="" disabled>Selecione</option>
              <option :value="true">Sim - Autorizo o uso da imagem do aluno</option>
              <option :value="false">Não</option>
            </select>
          </div>
        </div>

        </div>

        <!-- Dados do Plano Novo -->
        <h6 class="section-title">Dados do Plano Novo</h6>
        <div class="row mt-3 mb-3">
          <div class="col">
            <label class="form-label">Categoria: <span class="required">*</span></label>
            <select v-model="planoNovo.categoria_id" class="form-control" @change="carregarTiposPlano">
              <option value="">Selecione</option>
              <option v-for="c in categorias" :key="c.id" :value="c.id">{{ c.nome }}</option>
            </select>
          </div>
          <div class="col">
            <label class="form-label">Tipo de Plano: <span class="required">*</span></label>
            <select v-model="planoNovo.tipo_plano_id" class="form-control" @change="handleTipoPlanoChange">
              <option value="">Selecione</option>
              <option v-for="t in tiposPlano" :key="t.id" :value="t.id">
                {{ t.nome }} – {{ t.duracao }} dias
              </option>
            </select>
          </div>
          <div class="col">
            <label class="form-label">Aulas por Semana:</label>
            <input type="text" v-model="planoNovo.aulas_semana" class="form-control" disabled />
          </div>
          <div class="col">
            <label class="form-label">Qtd. de Parcelas:</label>
            <input type="text" v-model="planoNovo.quantidade_parcelas" class="form-control" disabled />
          </div>
        </div>
        <div class="row mb-4">
          <div class="col">
            <label class="form-label">Nível (Base): <span class="required">*</span></label>
            <select v-model="planoNovo.nivel_id" class="form-control" @change="onNivelBaseChange">
              <option value="">Selecione</option>
              <option v-for="n in niveis" :key="n.id" :value="n.id">{{ n.nivel }}</option>
            </select>
          </div>
          <div class="col">
            <label class="form-label">Início da Vigência: <span class="required">*</span></label>
            <input
              type="date"
              v-model="planoNovo.inicio_vigencia"
              class="form-control"
              @change="calcularTerminoVigencia"
            />
          </div>
          <div class="col">
            <label class="form-label">Término da Vigência:</label>
            <input
              type="date"
              v-model="planoNovo.termino_vigencia"
              class="form-control"
              disabled
            />

            <div class="form-check mt-2 d-flex align-items-center gap-2">
              <input
                id="encerrar_final_ano_renovacao"
                type="checkbox"
                class="form-check-input m-0"
                v-model="planoNovo.encerrar_vigencia_final_ano"
                @change="onEncerrarFinalAnoChange"
              />

              <label class="form-check-label mb-0" for="encerrar_final_ano_renovacao">
                Encerrar vigência no final do ano
              </label>
            </div>
          </div>
        </div>

        <!-- Turmas da Semana (✅ nível por linha) -->
        <div v-if="planoNovo.nivel_id" class="mb-4">
          <label class="form-label">Turmas da Semana: <span class="required">*</span></label>
          <div class="table-responsive">
            <table class="table table-borderless">
              <thead>
                <tr>
                  <th style="width: 240px;">Nível</th>
                  <th>Turma</th>
                  <th class="text-center">Ação</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(t, i) in planoNovo.turmas" :key="i">
                  <td>
                    <select v-model="t.nivel_id" class="form-control" @change="onNivelLinhaChange(i)">
                      <option :value="null" disabled>Selecione</option>
                      <option v-for="n in niveis" :key="n.id" :value="n.id">{{ n.nivel }}</option>
                    </select>
                  </td>
                  <td>
                    <select
                      v-model="t.turma_id"
                      class="form-control"
                      @change="atualizarTurma(i)"
                    >
                      <option value="" disabled>Selecione</option>
                      <option v-if="t.turma_id && !turmaDisponivel(t.turma_id, turmasDisponiveisPorNivel(t.nivel_id || planoNovo.nivel_id))" :value="t.turma_id" disabled>Turma anterior indisponível — selecione uma turma ativa</option>
                      <option
                        v-for="d in turmasDisponiveisPorNivel(t.nivel_id || planoNovo.nivel_id)"
                        :key="`${d.id}-${d.dia}-${d.horario}`"
                        :value="`${d.id}-${d.dia}-${d.horario}`"
                      >
                        Turma: {{ d.id }} | Dia: {{ d.dia }} | Hora: {{ d.horario_fmt }} | Instrutor: {{ d.instrutor }}
                      </option>
                    </select>
                  </td>
                  <td class="text-center">
                    <button class="btn btn-danger btn-sm" @click="removerTurma(i)">🗑️</button>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- <div v-if="temNivelMisto" class="text-muted small text-end mt-1">
              Renovação com turmas em níveis distintos (ex.: individual). Se necessário, você pode lançar cobranças extras.
            </div> -->
          </div>
        </div>

        <!-- Até 120 dias, a cobrança pode ser escolhida; acima disso é automática. -->
        <div v-if="podeCobrarMatriculaOpcional" class="form-check mb-3 d-flex align-items-center gap-2">
          <input id="cobrar-matricula" v-model="cobrarMatricula" type="checkbox" class="form-check-input m-0" />
          <label for="cobrar-matricula" class="form-check-label mb-0">Cobrar matrícula</label>
        </div>
        <div v-if="deveCobrarMatricula" class="mb-4">
          <h6 class="section-title">Dados Financeiros</h6>
          <div class="row mt-3 mb-3">
            <div class="col-md-2">
              <label class="form-label">Data da Matrícula: <span class="required">*</span></label>
              <input
                type="date"
                v-model="editablePlano.data_matricula"
                class="form-control"
                required
              />
            </div>
            <div class="col-md-3">
              <label class="form-label">Valor:</label>
              <input
                type="text"
                v-model="matriculaValorInput"
                inputmode="decimal"
                class="form-control"
                @input="editarValorMatricula"
                @blur="formatarValorMatricula"
              />
            </div>
            <div class="col-md-2">
              <label class="form-label">Desconto (%):</label>
              <input
                type="number"
                v-model="editablePlano.desconto"
                class="form-control"
                min="0"
                max="100"
                @input="calcularValorComDesconto"
              />
            </div>
            <div class="col-md-3">
              <label class="form-label">Valor com Desconto:</label>
              <input
                type="text"
                :value="globalUtils.formatarValor(editablePlano.valor_com_desconto)"
                class="form-control"
                disabled
              />
            </div>
            <div class="col-md-2">
              <label class="form-label">Convênio:</label>
              <select
                v-model="editablePlano.convenio_id"
                class="form-control"
                @change="atualizarDescontoConvenio"
              >
                <option value="">Selecione</option>
                <option v-for="c in convenios" :key="c.id" :value="c.id">{{ c.nome }}</option>
              </select>
            </div>
          </div>

          <div class="row mt-3">
            <div :class="isCartao(editablePlano.forma_pagamento_id) ? 'col-md-3' : 'col-md-2'">
              <label class="form-label">Forma de Pagamento: <span class="required">*</span></label>
              <select
                v-model="editablePlano.forma_pagamento_id"
                class="form-control"
                required
              >
                <option value="">Selecione</option>
                <option v-for="f in formasPagamento" :key="f.id" :value="f.id">{{ f.nome }}</option>
              </select>

              <!-- Autorização do Cartão (Dados Financeiros) -->
              <div class="mt-2" v-if="isCartao(editablePlano.forma_pagamento_id)">
                <label class="form-label">Autorização <span class="required">*</span></label>
                <input
                  type="text"
                  v-model="editablePlano.numero_autorizacao"
                  class="form-control"
                  placeholder="Digite o número da autorização"
                  :disabled="isAInformar(editablePlano.forma_pagamento_id)"
                />
              </div>

            </div>

            <div v-if="isCheque(editablePlano.forma_pagamento_id)" class="col-md-3 d-flex">
              <div class="flex-fill me-2">
                <label class="form-label">Banco nº: <span class="required">*</span></label>
                <input type="text" v-model="editablePlano.banco_numero" class="form-control" required />
              </div>
              <div class="flex-fill me-2">
                <label class="form-label">Agência: <span class="required">*</span></label>
                <input type="text" v-model="editablePlano.agencia" class="form-control" required />
              </div>
              <div class="flex-fill">
                <label class="form-label">Cheque nº: <span class="required">*</span></label>
                <input type="text" v-model="editablePlano.cheque_numero" class="form-control" required />
              </div>
            </div>

            <div class="col-md-2">
              <label class="form-label">Conta Financeira: <span class="required">*</span></label>
              <select
                v-model="editablePlano.conta_financeira_id"
                class="form-control"
                required
              >
                <option value="" disabled>Selecione</option>
                <option v-for="c in contasFinanceiras" :key="c.id" :value="String(c.id)">
                  {{ c.apelido }}
                </option>
              </select>
            </div>

            <div class="col-md-2">
              <label class="form-label">Data de Vencimento: <span class="required">*</span></label>
              <input type="date" v-model="editablePlano.data_vencimento" class="form-control" disabled />
            </div>
            <div class="col-md-2">
              <label class="form-label">Data de Pagamento:</label>
              <input type="date" v-model="editablePlano.data_pagamento" class="form-control" />
            </div>
            <div class="col-md-2">
              <label class="form-label">Data de Recebimento:</label>
              <input type="date" v-model="editablePlano.data_recebimento" class="form-control" disabled />
            </div>
          </div>
        </div>

        <!-- Mensalidade -->
        <h6 class="section-title">Mensalidade</h6>
        <div class="row mt-3 mb-3">
          <div class="col-md-2">
            <label class="form-label">Valor:</label>
            <input
              type="text"
              class="form-control"
              v-model="mensalidadeValorInput"
              @focus="desformatarValorMensalidade"
              @blur="formatarValorMensalidade"
              placeholder="0,00"
            />
          </div>

          <div class="col-md-2">
            <label class="form-label">Desconto (%):</label>

            <!-- Se o desconto veio do benefício, mantém somente leitura -->
            <template v-if="beneficio?.tipo === 'desconto'">
              <input
                type="text"
                class="form-control"
                :value="descontoSomenteLeitura"
                readonly
              />
            </template>

            <!-- Caso contrário, usuário pode editar -->
            <template v-else>
              <input
                type="text"
                inputmode="decimal"
                class="form-control"
                v-model="mensalidade.desconto"
                placeholder="(sem desconto)"
              />
            </template>
          </div>

          <div
            v-if="renovacaoManagedAtiva"
            class="col-md-2"
          >
            <label class="form-label">
              Dia de Vencimento:
              <span class="required">*</span>
            </label>

            <select
              v-model="diaVencimentoMensalidadeRenovacao"
              class="form-control"
              :disabled="
                carregandoDiasVencimentoCobranca ||
                diaVencimentoHerdadoFrontend
              "
              @change="onDiaVencimentoRenovacaoChange"
            >
              <option value="">Selecione</option>
              <option
                v-for="item in diasVencimentoCobranca"
                :key="item.dia"
                :value="String(item.dia)"
              >
                Dia {{ item.dia }}
              </option>
            </select>

            <small
              v-if="diaVencimentoHerdadoFrontend"
              class="text-muted"
            >
              Herdado do contrato atual.
            </small>

            <small
              v-else-if="erroPoliticaCobranca"
              class="text-danger"
            >
              {{ erroPoliticaCobranca }}
            </small>
          </div>

          <div class="col-md-2">
            <label class="form-label">Valor c/ Desconto:</label>
            <input
              type="text"
              :value="formatarValor(mensalidade.valor_com_desconto)"
              class="form-control"
              disabled
            />
          </div>

          <div class="col-md-2">
            <label class="form-label">
              {{ renovacaoManagedAtiva ? '1º Vencimento (prévia):' : '1º Vencimento:' }}
              <span class="required">*</span>
            </label>
            <input
              type="date"
              v-model="mensalidade.primeiro_vencimento"
              class="form-control"
              :disabled="renovacaoManagedAtiva"
            />
          </div>

          <div class="col-md-2">
            <label class="form-label">Qtd. de Pagamentos:</label>
            <input type="text" :value="mensalidade.quantidade_pagamentos" class="form-control" disabled />
          </div>

          <div class="col-md-2">
            <label class="form-label">
              {{ renovacaoManagedAtiva ? 'Valor Contratual:' : 'Valor Total:' }}
            </label>
            <input type="text" :value="formatarValor(mensalidade.valor_total)" class="form-control" disabled />
          </div>
        </div>

        <!-- Pagamentos -->
        <div
          v-if="renovacaoManagedAtiva"
          class="alert alert-info py-2 px-3"
        >
          As mensalidades regulares serão geradas automaticamente
          pelo sistema. As linhas regulares abaixo são apenas uma
          prévia e devem usar a forma <strong>Boleto</strong> e a
          mesma conta financeira. Pagamentos adicionais continuam
          sendo lançados separadamente.
        </div>


        <div
          v-if="
            renovacaoManagedAtiva &&
            carregandoPreviewRenovacaoManaged
          "
          class="alert alert-info py-2 px-3"
        >
          <i class="bi bi-hourglass-split me-1"></i>
          Calculando a prévia financeira da renovação pela política de cobrança...
        </div>

        <div
          v-if="
            renovacaoManagedAtiva &&
            erroPreviewRenovacaoManaged
          "
          class="alert alert-warning py-2 px-3"
        >
          <i class="bi bi-exclamation-triangle-fill me-1"></i>
          {{ erroPreviewRenovacaoManaged }}
        </div>

        <div
          v-if="
            renovacaoManagedAtiva &&
            previewRenovacaoManaged
          "
          class="mb-3"
        >
          <div class="row g-2">
            <div class="col-md-4">
              <div class="border rounded p-2 h-100">
                <small class="text-muted d-block">
                  Total contratual
                </small>

                <strong>
                  {{ globalUtils.formatarValor(
                    previewRenovacaoManaged.resumo.total_contratual
                  ) }}
                </strong>
              </div>
            </div>

            <div class="col-md-4">
              <div class="border rounded p-2 h-100">
                <small class="text-muted d-block">
                  Pró-rata
                </small>

                <strong>
                  +{{ globalUtils.formatarValor(
                    previewRenovacaoManaged.resumo.total_prorata
                  ) }}
                </strong>
              </div>
            </div>

            <div class="col-md-4">
              <div class="border rounded p-2 h-100 bg-light">
                <small class="text-muted d-block">
                  Total previsto
                </small>

                <strong>
                  {{ globalUtils.formatarValor(
                    previewRenovacaoManaged.resumo.total_obrigacoes
                  ) }}
                </strong>
              </div>
            </div>
          </div>

          <div class="alert alert-info py-2 px-3 mt-2 mb-0">
            <i class="bi bi-info-circle-fill me-1"></i>

            {{ mensagemPreviewProrataRenovacaoManaged }}

            <div
              v-if="primeiroTituloPreviewRenovacaoManaged"
              class="mt-1"
            >
              <strong>Primeiro título previsto:</strong>

              {{ globalUtils.formatarValor(
                primeiroTituloPreviewRenovacaoManaged.valor
              ) }}

              com vencimento em

              {{ globalUtils.formatarData(
                primeiroTituloPreviewRenovacaoManaged.data_vencimento
              ) }}.
            </div>
          </div>
        </div>

        <div v-if="mensalidade.pagamentos.length" class="mb-3">

          <div class="mb-2">
            <div class="alert py-2 px-3 mb-2"
                :class="divergenciaTotal ? 'alert-warning' : 'alert-light'">
              <div class="d-flex justify-content-between align-items-center flex-wrap">
                <div>
                  <strong>Total calculado pelas parcelas:</strong>
                  {{ totalParcelasFormatado }}

                  <span v-if="divergenciaTotal" class="ms-2 text-danger">
                    ⚠️ Divergente do {{ renovacaoManagedAtiva ? 'Total previsto' : 'Valor Total' }} ({{ totalOficialFormatado }})
                  </span>
                </div>

                <div v-if="divergenciaTotal"
                    class="fw-bold ms-3"
                    :class="diferencaTotal < 0 ? 'text-danger' : 'text-primary'">
                  {{ diferencaLabel }}
                </div>
              </div>
            </div>
          </div>

          <table class="table table-borderless">
            <thead>
              <tr>
                <th>#</th>
                <th>Forma <span class="required">*</span></th>
                <th>Autorização</th>
                <th>Vencimento</th>
                <th>Valor</th>
                <th>Pagamento <span class="required">*</span></th>
                <th>Recebimento</th>
                <th>Conta <span class="required">*</span></th>
                <th v-if="existeCheque">Banco nº <span class="required">*</span></th>
                <th v-if="existeCheque">Agência <span class="required">*</span></th>
                <th v-if="existeCheque">Cheque nº <span class="required">*</span></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(p, idx) in mensalidade.pagamentos" :key="idx">
                <td>{{ idx + 1 }}</td>

                <td>
                  <select
                    v-model="p.forma_pagamento_id"
                    @change="onPagamentoFormaChange(p)"
                    class="form-control"
                    required
                  >
                    <option value="">Selecione</option>
                    <option v-for="f in formasPagamento" :key="f.id" :value="f.id">{{ f.nome }}</option>
                  </select>
                </td>

                <td>
                  <input
                    v-if="isFormaComAutorizacao(p.forma_pagamento_id)"
                    v-model="p.numero_autorizacao"
                    type="text"
                    class="form-control"
                    placeholder="Autorização"
                    @input="onNumeroAutorizacaoMensalInput(p)"
                    :disabled="isAInformar(p.forma_pagamento_id)"
                  />
                </td>

                <td>
                  <input type="date" v-model="p.data_vencimento" class="form-control" disabled />
                </td>

                <td>
                  <input
                    type="text"
                    :value="globalUtils.formatarValor(toNumberBR(p.valor))"
                    class="form-control"
                    :readonly="isParcelaQuitada(p)"
                    @focus="onParcelaValorFocus($event, p)"
                    @blur="onParcelaValorBlur($event, p)"
                    placeholder="0,00"
                  />
                </td>

                <td>
                  <input
                    type="date"
                    v-model="p.data_pagamento"
                    class="form-control"
                    :disabled="isAInformar(p.forma_pagamento_id)"
                  />
                </td>

                <td>
                  <input
                    type="date"
                    v-model="p.data_recebimento"
                    class="form-control"
                    disabled
                  />
                </td>

                <td>
                  <select
                    v-model="p.conta_financeira_id"
                    :disabled="isAInformar(p.forma_pagamento_id)"
                    class="form-control"
                    @change="onContaFinanceiraMensalChange(p)"
                  >
                    <option v-if="isAInformar(p.forma_pagamento_id)" :value="null">A informar</option>

                    <template v-else>
                      <option value="" disabled>Selecione</option>
                      <option v-for="c in contasFinanceiras" :key="c.id" :value="String(c.id)">
                        {{ c.apelido }}
                      </option>
                    </template>
                  </select>
                </td>

                <td v-if="isCheque(p.forma_pagamento_id)">
                  <input type="text" v-model="p.banco_numero" class="form-control" placeholder="Banco nº" />
                </td>
                <td v-if="isCheque(p.forma_pagamento_id)">
                  <input type="text" v-model="p.agencia" class="form-control" placeholder="Agência" />
                </td>
                <td v-if="isCheque(p.forma_pagamento_id)">
                  <input type="text" v-model="p.cheque_numero" class="form-control" placeholder="Cheque nº" />
                </td>

                <td class="text-center">
                  <button class="btn btn-danger btn-sm" @click="removerPagamento(idx)">🗑️</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Observações -->
        <div class="mb-3">
          <label class="form-label">Observações:</label>
          <textarea v-model="mensalidade.observacoes" class="form-control" rows="3"></textarea>
        </div>
      </div>

      <!-- Rodapé -->
      <div class="modal-footer">
        <button class="btn btn-secondary" @click="cancel">Cancelar</button>
        <button
          :class="['btn', isSaving ? 'btn-success' : 'btn-primary']"
          :disabled="!formValid || isSaving"
          @click="renovar"
        >
          {{ isSaving ? 'Renovando…' : 'Renovar' }}
        </button>
      </div>
    </div>
  </div>

  <RenovarMatriculaBrinde
    v-if="showBrindeModal"
    @confirm="onConfirmBeneficio"
    @cancel="onCancelBeneficio"
    :dias-antecedencia="diasAntecedencia"
  />

</template>

<script>
import { turmaDisponivel, mensagemTurmaIndisponivel } from '@/utils/turmasSelecao';
import { reactive, ref, computed, onMounted, watch, watchEffect, getCurrentInstance } from 'vue';

import axios from '@/services/axios';
import globalUtils from '@/utils/globalUtils.js';
import RenovarMatriculaBrinde from '@/components/modals/RenovarMatriculaBrinde.vue';

const isRebuilding = ref(false);

// const showBrindeModal = ref(false)
// const beneficio = ref(null) // { tipo:'brinde'| 'desconto', ... }


export default {
  name: 'RenovarMatricula',
  components: {
    RenovarMatriculaBrinde,
  },
  props: {
    planoAtual: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  setup(props, { emit }) {
    const cobrarMatricula = ref(false);

    // Capture a instância do componente
    const instance = getCurrentInstance();
    if (!instance) {
      throw new Error("getCurrentInstance retornou null. Verifique se a função está dentro do setup.");
    }

    const matriculaEstaCancelada = () => coerceBool(props.planoAtual?.cancelada) === true;

    // ============================
    // ✅ TURMAS: base completa + por nível (igual Formulario / Trocar Nível)
    // ============================
    const todasTurmasDisponiveis = ref([]);

    const idxDia = (d) => {
      let s = String(d || '')
        .normalize('NFD').replace(/\p{Diacritic}/gu, '')
        .toLowerCase().replace(/-?feira/g, '').trim();
      s = s.split(/\s+/)[0].slice(0,3); // seg, ter, qua, qui, sex, sab, dom
      const mapa = { seg:1, ter:2, qua:3, qui:4, sex:5, sab:6, dom:7 };
      return mapa[s] ?? 99;
    };

    const toMin = (h) => {
      const m = String(h || '').match(/^(\d{1,2}):(\d{2})(?::\d{2})?/);
      if (!m) return Number.MAX_SAFE_INTEGER;
      return (+m[1]) * 60 + (+m[2]);
    };

    const formatHora = (h) => {
      const m = String(h||'').match(/^(\d{1,2}):(\d{2})(?::\d{2})?$/);
      return m ? `${m[1].padStart(2,'0')}:${m[2]}` : String(h||'');
    };

    function turmasDisponiveisPorNivel(nivelId) {
      const nId = Number(nivelId);
      const base = (todasTurmasDisponiveis.value || []).filter(t => Number(t.nivel_id) === nId);
      return base.sort((a,b) =>
        (Number(a.id) - Number(b.id)) ||
        (idxDia(a.dia) - idxDia(b.dia)) ||
        (toMin(a.horario) - toMin(b.horario))
      );
    }

    const carregarTodasTurmas = async () => {
      try {
        const res = await axios.get('/cadastros/dias-horarios-turmas', { params: { ativo: true } });
        const linhas = res.data.data || res.data || [];

        // mapa nome do nível -> id (precisa de niveis carregado)
        const nivelNomeToId = new Map((niveis.value || []).map(n => [String(n.nivel).trim(), Number(n.id)]));

        const processadas = (Array.isArray(linhas) ? linhas : []).map(t => {
          const nivelNome = t.nivel_nome || t.nivel || '';
          const nivelId = Number(t.nivel_id ?? nivelNomeToId.get(String(nivelNome).trim()) ?? null);
          if (!Number.isFinite(nivelId)) return null;

          return {
            id: t.turma_id ?? t.id,
            dia: t.dia_semana ?? t.dia,
            horario: t.horario,                 // HH:MM:SS
            horario_fmt: formatHora(t.horario), // HH:MM
            instrutor: t.instrutor_nome || 'Não informado',
            nivel: nivelNome,
            nivel_id: nivelId
          };
        }).filter(Boolean);

        todasTurmasDisponiveis.value = processadas;
      } catch (error) {
        console.error('❌ Erro ao carregar turmas:', error);
        todasTurmasDisponiveis.value = [];
      }
    };

    const keyDiaHora = (dia, horario) => `${idxDia(dia)}__${String(horario||'').slice(0,5)}`;
    const hasChoqueComOutraLinha = (dia, horario, idxAtual) => {
      const k = keyDiaHora(dia, horario);
      return (planoNovo.turmas || []).some((t, i) =>
        i !== idxAtual && t && t.dia && t.horario && keyDiaHora(t.dia, t.horario) === k
      );
    };

    // Dados do novo plano
    const planoNovo = reactive({
      categoria_id: '',
      tipo_plano_id: '',
      nivel_id: '',
      inicio_vigencia: '',
      termino_vigencia: '',
      aulas_semana: '',
      quantidade_parcelas: '',
      encerrar_vigencia_final_ano: false,
      turmas: []
    });

    // Dados da mensalidade
    const mensalidade = reactive({
      valor: 0,
      desconto: 0,
      valor_com_desconto: 0,
      primeiro_vencimento: '',
      quantidade_pagamentos: '',
      valor_total: 0,
      observacoes: '',
      pagamentos: []
    });

    const mensalidadeValorInput = ref('')  // texto que aparece no input (pt-BR)
    const isEditingMensalidadeValor = ref(false)

    function onParcelaValorFocus(e, pag) {
      if (!pag || isParcelaQuitada(pag)) return;
      const v = Number(toNumberBR(pag.valor) || 0);
      e.target.value = v.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function onParcelaValorBlur(e, pag) {
      if (!pag || isParcelaQuitada(pag)) return;
      const n = toNumberBR(e.target.value);
      pag.valor = Number.isFinite(n) ? Number(n.toFixed(2)) : 0;
    }


    // helper: "1.234,56" / "1234,56" / "R$ 1.234,56" -> 1234.56
    function toNumberBR(v) {
      if (typeof v === 'number') return v
      if (v == null || v === '') return 0
      let s = String(v).trim()
      s = s.replace(/\s/g, '').replace(/^R\$\s?/, '')
      s = s.replace(/\./g, '').replace(',', '.')
      const n = Number(s)
      return Number.isFinite(n) ? n : 0
    }

    // 1234.5 -> "1.234,50" (sem "R$")
    function formatBR2(n) {
      const num = Number(n || 0);
      return num.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    // ✅ trava só quando realmente quitada (pagamento + conta)
    // (se quiser ser mais rígido: exigir também recebimento, mas no teu fluxo recebimento é calculado)
    function isParcelaQuitada(p) {
      return Boolean((p?.data_pagamento || '').trim() && p?.conta_financeira_id);
    }

    function desformatarValorParcela(p) {
      if (!p || isParcelaQuitada(p)) return;
      // no foco: deixa sem R$ e com 2 casas (pra digitar)
      p.valor = formatBR2(toNumberBR(p.valor)); // "511,00"
    }

    function formatarValorParcela(p) {
      if (!p || isParcelaQuitada(p)) return;
      // no blur: exibe com R$
      const n = toNumberBR(p.valor);
      p.valor = globalUtils.formatarValor(Number(n.toFixed(2))); // "R$ 511,00"
    }

    function normalizarValoresParcelas() {
      (mensalidade.pagamentos || []).forEach(p => {
        // para parcelas normais e adicionais, você pode padronizar igual
        const n = toNumberBR(p.valor);
        p.valor = globalUtils.formatarValor(Number(n.toFixed(2))); // "R$ 511,00"
      });
    }

    function remontarParcelasSemRecalcularTotal() {
      if (isRebuilding.value) return;
      isRebuilding.value = true;
      try {
        // não chama calcularBasicosMensalidade()
        mensalidade.pagamentos = [];
        distribuirParcelasMensalidade(true);
        normalizarValoresParcelas();
      } finally {
        isRebuilding.value = false;
      }
    }

    function desformatarValorMensalidade() {
      isEditingMensalidadeValor.value = true
      // mostra número “cru” com vírgula, facilita digitação
      const n = Number(mensalidade.valor || 0)
      mensalidadeValorInput.value = n
        ? n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        : ''
    }

    function formatarValorMensalidade() {
      // salva no state numérico
      const n = toNumberBR(mensalidadeValorInput.value)
      mensalidade.valor = Number(n.toFixed(2))

      // volta a exibir formatado (R$)
      mensalidadeValorInput.value = globalUtils.formatarValor(mensalidade.valor)

      isEditingMensalidadeValor.value = false

      // recalcula tudo (valor_com_desconto, total e parcelas)
      remontarParcelas()
    }

    /*
     * RENOVACAO_MANAGED_FRONTEND_6_5B
     *
     * Somente valor/desconto contratuais managed usam estes
     * normalizadores textuais como autoridade. O fluxo legacy
     * mantém os cálculos numéricos já existentes.
     */
    const normalizarMoedaContratualTexto = (value) => {
      let text = String(value ?? '')
        .trim()
        .replace(/\s+/g, '')
        .replace(/^R\$/i, '');

      if (!text) return null;

      if (text.includes(',')) {
        text = text
          .replace(/\./g, '')
          .replace(',', '.');
      }

      const match =
        /^(\d+)(?:\.(\d{0,2}))?$/
          .exec(text);

      if (!match) return null;

      const inteiro =
        match[1]
          .replace(/^0+(?=\d)/, '') ||
        '0';

      const fracao =
        String(match[2] || '')
          .padEnd(2, '0');

      return `${inteiro}.${fracao}`;
    };

    const normalizarPercentualContratualTexto = (value) => {
      const text = String(value ?? '')
        .trim()
        .replace(',', '.');

      const match =
        /^(\d+)(?:\.(\d{0,6}))?$/
          .exec(text);

      if (!match) return null;

      const inteiro =
        match[1]
          .replace(/^0+(?=\d)/, '') ||
        '0';

      const fracaoInformada =
        String(match[2] || '');

      const fracaoSeis =
        fracaoInformada.padEnd(6, '0');

      if (
        inteiro.length > 3 ||
        (
          inteiro.length === 3 &&
          inteiro > '100'
        ) ||
        (
          inteiro === '100' &&
          fracaoSeis !== '000000'
        ) ||
        (
          fracaoInformada.length > 2 &&
          /[1-9]/.test(
            fracaoInformada.slice(2)
          )
        )
      ) {
        return null;
      }

      const fracaoDuas =
        fracaoInformada
          .padEnd(2, '0')
          .slice(0, 2);

      return `${inteiro}.${fracaoDuas}`;
    };

    const calcularPrimeiroVencimentoRegularManaged = (
      dataInicio,
      diaVencimento
    ) => {
      const match =
        /^(\d{4})-(\d{2})-(\d{2})$/
          .exec(
            String(dataInicio || '').trim()
          );

      const dia =
        Number(diaVencimento);

      if (
        !match ||
        !Number.isInteger(dia) ||
        dia < 1 ||
        dia > 28
      ) {
        return null;
      }

      let ano =
        Number(match[1]);

      let mes =
        Number(match[2]) + 1;

      if (mes > 12) {
        mes = 1;
        ano += 1;
      }

      return (
        String(ano).padStart(4, '0') +
        '-' +
        String(mes).padStart(2, '0') +
        '-' +
        String(dia).padStart(2, '0')
      );
    };

    const norm = (s) => (s ?? '')
      .toString()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .trim().toLowerCase();

    const getFormaById = (id) => formasPagamento.value.find(f => Number(f.id) === Number(id));

    const isCartao = (formaId) => {
      const forma = getFormaById(formaId);
      const n = norm(forma?.nome);
      return n.includes('cartao');
    };

    const isCartaoCreditoAVista = (formaId) => {
      const forma = getFormaById(formaId);
      const n = norm(forma?.nome);
      return (
        n === 'cartao de credito' ||
        n === 'cartao de credito a vista' ||
        (n.includes('cartao') && n.includes('credito') && n.includes('vista'))
      );
    };

    const isCartaoCreditoParcelado = (formaId) => {
      const forma = getFormaById(formaId);
      const n = norm(forma?.nome);
      return n.includes('cartao') && n.includes('credito') && n.includes('parcelado');
    };

    const isCartaoCredito = (formaId) => {
      return isCartaoCreditoAVista(formaId) || isCartaoCreditoParcelado(formaId);
    };

    const isCartaoDebito = (formaId) => {
      const forma = getFormaById(formaId);
      const n = norm(forma?.nome);
      return n.includes('cartao') && n.includes('debito');
    };

    const isFormaComAutorizacao = (formaId) => {
      return (
        isCartaoCreditoAVista(formaId) ||
        isCartaoCreditoParcelado(formaId) ||
        isCartaoDebito(formaId)
      );
    };

    const getPagamentosMensalidadeOrdenados = () => {
      return (mensalidade.pagamentos || [])
        .filter(p => !p.adicional)
        .slice()
        .sort((a, b) => String(a?.data_vencimento || '').localeCompare(String(b?.data_vencimento || '')));
    };

    const getBlocoParceladoDaParcela = (pag) => {
      const lista = getPagamentosMensalidadeOrdenados();
      const idx = lista.findIndex(p => p === pag);

      if (idx === -1) return [];
      if (!isCartaoCreditoParcelado(lista[idx]?.forma_pagamento_id)) return [lista[idx]];

      let ini = idx;
      let fim = idx;

      while (ini > 0 && isCartaoCreditoParcelado(lista[ini - 1]?.forma_pagamento_id)) ini--;
      while (fim < lista.length - 1 && isCartaoCreditoParcelado(lista[fim + 1]?.forma_pagamento_id)) fim++;

      return lista.slice(ini, fim + 1);
    };

    const getNumeroParcelaNoBlocoParcelado = (pag) => {
      const bloco = getBlocoParceladoDaParcela(pag);
      const idx = bloco.findIndex(p => p === pag);
      return idx >= 0 ? idx + 1 : 1;
    };

    const isInicioBlocoParcelado = (pag) => {
      if (!isCartaoCreditoParcelado(pag?.forma_pagamento_id)) return false;

      const lista = getPagamentosMensalidadeOrdenados();
      const idx = lista.findIndex(p => p === pag);

      if (idx === -1) return false;
      if (idx === 0) return true;

      return !isCartaoCreditoParcelado(lista[idx - 1]?.forma_pagamento_id);
    };

    const propagarBlocoParceladoParaLinhasVazias = (pag) => {
      if (!isInicioBlocoParcelado(pag)) return;

      const lista = getPagamentosMensalidadeOrdenados();
      const idx = lista.findIndex(p => p === pag);

      if (idx === -1) return;

      const autorizacao = (pag.numero_autorizacao || '').trim();
      const conta = pag.conta_financeira_id ?? null;

      for (let i = idx + 1; i < lista.length; i++) {
        const atual = lista[i];
        const formaAtual = atual?.forma_pagamento_id;

        // para ao encontrar uma próxima linha já definida
        if (formaAtual !== null && formaAtual !== '' && formaAtual !== undefined) {
          break;
        }

        atual.forma_pagamento_id = pag.forma_pagamento_id;

        if (!(atual.numero_autorizacao || '').trim() && autorizacao) {
          atual.numero_autorizacao = autorizacao;
        }

        if (
          (atual.conta_financeira_id === null ||
            atual.conta_financeira_id === '' ||
            atual.conta_financeira_id === undefined) &&
          conta
        ) {
          atual.conta_financeira_id = conta;
        }

        if (!atual.data_pagamento) {
          atual.data_pagamento = atual.data_vencimento || null;
        }
      }
    };

    const getDataBaseBlocoParcelado = (pag) => {
      const bloco = getBlocoParceladoDaParcela(pag);
      const primeira = bloco?.[0];

      if (!primeira) return null;

      return (
        primeira.data_pagamento ||
        primeira.data_vencimento ||
        pag.data_pagamento ||
        pag.data_vencimento ||
        null
      );
    };

    const replicarAutorizacaoNoBlocoParcelado = (pag) => {
      if (!isCartaoCreditoParcelado(pag?.forma_pagamento_id)) return;
      const bloco = getBlocoParceladoDaParcela(pag);
      const valor = (pag.numero_autorizacao || '').trim();
      bloco.forEach(p => {
        p.numero_autorizacao = valor;
      });
    };

    const replicarContaNoBlocoParcelado = (pag) => {
      if (!isCartaoCreditoParcelado(pag?.forma_pagamento_id)) return;
      const bloco = getBlocoParceladoDaParcela(pag);
      const conta = pag.conta_financeira_id ?? null;
      bloco.forEach(p => {
        p.conta_financeira_id = conta;
      });
    };

    const onNumeroAutorizacaoMensalInput = (pag) => {
      if (isCartaoCreditoParcelado(pag?.forma_pagamento_id)) {
        replicarAutorizacaoNoBlocoParcelado(pag);
      }
    };

    const onContaFinanceiraMensalChange = (pag) => {
      if (
        !pag?.adicional &&
        isBoletoSemantico(
          pag?.forma_pagamento_id
        )
      ) {
        propagarContaBoletoRegular(
          pag
        );
        return;
      }

      if (isCartaoCreditoParcelado(pag?.forma_pagamento_id)) {
        replicarContaNoBlocoParcelado(pag);
      }
    };

    // Arrays reativos para preenchimento dos selects
    const categorias = ref([]);
    const tiposPlano = ref([]);
    const niveis = ref([]);
    const turmasDisponiveis = ref([]); // mantido (não usado na nova UX, mas não quebra nada)
    const formasPagamento = ref([]);

    const diasVencimentoCobranca = ref([]);
    const carregandoDiasVencimentoCobranca = ref(false);
    const erroPoliticaCobranca = ref('');
    const politicaCobrancaAplicavelId = ref(null);
    const diaVencimentoMensalidadeRenovacao = ref('');
    const diaVencimentoHerdadoFrontend = ref(false);

    const previewRenovacaoManaged =
      ref(null);

    const carregandoPreviewRenovacaoManaged =
      ref(false);

    const erroPreviewRenovacaoManaged =
      ref('');

    let sequenciaPreviewRenovacaoManaged =
      0;

    let sequenciaCargaPoliticaCobranca = 0;

    const convenios = ref([]);
    const aulasSemanaOptions = ref([1, 2, 3, 4, 5, 6]);
    const parcelasOptions = ref(Array.from({ length: 12 }, (_, i) => i + 1));

    const contratoAtualGerenciado =
      computed(() => {
        const id =
          Number(
            props.planoAtual
              ?.politica_cobranca_id
          );

        return (
          Number.isInteger(id) &&
          id > 0
        );
      });

    const isBoletoSemantico = (formaId) => {
      const forma =
        getFormaById(formaId);

      if (!forma) return false;

      return (
        String(
          forma.codigo_sistema ||
          ''
        )
          .trim()
          .toUpperCase() ===
        'BOLETO'
      );
    };

    const parcelasRegularesRenovacao =
      () =>
        (mensalidade.pagamentos || [])
          .filter(p => !p.adicional);

    const renovacaoManagedAtiva =
      computed(() => {
        if (
          contratoAtualGerenciado
            .value
        ) {
          return true;
        }

        return parcelasRegularesRenovacao()
          .some(
            p =>
              isBoletoSemantico(
                p.forma_pagamento_id
              )
          );
      });

    const propagarBoletoRegular = (origem) => {
      if (
        !origem ||
        origem.adicional ||
        !isBoletoSemantico(
          origem.forma_pagamento_id
        )
      ) {
        return;
      }

      const conta =
        origem.conta_financeira_id ??
        null;

      for (
        const p of
        parcelasRegularesRenovacao()
      ) {
        p.forma_pagamento_id =
          origem.forma_pagamento_id;

        p.numero_autorizacao = null;
        p.data_pagamento = null;
        p.data_recebimento = null;

        if (
          conta !== null &&
          conta !== ''
        ) {
          p.conta_financeira_id =
            conta;
        }
      }
    };

    const propagarContaBoletoRegular = (origem) => {
      if (
        !origem ||
        origem.adicional ||
        !isBoletoSemantico(
          origem.forma_pagamento_id
        )
      ) {
        return;
      }

      const conta =
        origem.conta_financeira_id ??
        null;

      for (
        const p of
        parcelasRegularesRenovacao()
      ) {
        p.forma_pagamento_id =
          origem.forma_pagamento_id;

        p.conta_financeira_id =
          conta;

        p.numero_autorizacao = null;
        p.data_pagamento = null;
        p.data_recebimento = null;
      }
    };

    const atualizarPrimeiroVencimentoManaged = () => {
      if (
        !renovacaoManagedAtiva
          .value
      ) {
        return;
      }

      const primeiro =
        calcularPrimeiroVencimentoRegularManaged(
          planoNovo.inicio_vigencia,
          diaVencimentoMensalidadeRenovacao.value
        );

      mensalidade.primeiro_vencimento =
        primeiro ||
        '';
    };

    const onDiaVencimentoRenovacaoChange = () => {
      diaVencimentoHerdadoFrontend.value =
        false;

      atualizarPrimeiroVencimentoManaged();
    };

    const carregarDiasVencimentoRenovacao = async () => {
      const dataInicio =
        String(
          planoNovo.inicio_vigencia ||
          ''
        ).trim();

      const seq =
        ++sequenciaCargaPoliticaCobranca;

      if (!dataInicio) {
        diasVencimentoCobranca.value = [];
        politicaCobrancaAplicavelId.value = null;
        erroPoliticaCobranca.value = '';
        diaVencimentoHerdadoFrontend.value = false;
        return false;
      }

      carregandoDiasVencimentoCobranca.value = true;
      erroPoliticaCobranca.value = '';

      try {
        const { data } =
          await axios.get(
            '/operacional/matriculas/politica-cobranca-aplicavel',
            {
              params: {
                data_inicio:
                  dataInicio
              }
            }
          );

        if (
          seq !==
          sequenciaCargaPoliticaCobranca
        ) {
          return false;
        }

        const dias =
          Array.isArray(
            data?.dias_vencimento
          )
            ? data.dias_vencimento
                .map(
                  item => ({
                    dia:
                      Number(item?.dia),

                    padrao:
                      item?.padrao ===
                      true
                  })
                )
                .filter(
                  item =>
                    Number.isInteger(
                      item.dia
                    ) &&
                    item.dia >= 1 &&
                    item.dia <= 28
                )
                .sort(
                  (a, b) =>
                    a.dia -
                    b.dia
                )
            : [];

        diasVencimentoCobranca.value =
          dias;

        const politicaId =
          Number(
            data?.politica_cobranca_id
          );

        politicaCobrancaAplicavelId.value =
          (
            Number.isInteger(
              politicaId
            ) &&
            politicaId > 0
          )
            ? politicaId
            : null;

        const diaAtualContrato =
          Number(
            props.planoAtual
              ?.dia_vencimento_mensalidade
          );

        const diaAtualPermitido =
          contratoAtualGerenciado.value &&
          Number.isInteger(
            diaAtualContrato
          ) &&
          dias.some(
            item =>
              item.dia ===
              diaAtualContrato
          );

        if (diaAtualPermitido) {
          diaVencimentoMensalidadeRenovacao.value =
            String(
              diaAtualContrato
            );

          diaVencimentoHerdadoFrontend.value =
            true;
        } else {
          diaVencimentoHerdadoFrontend.value =
            false;

          const selecionado =
            Number(
              diaVencimentoMensalidadeRenovacao.value
            );

          if (
            !Number.isInteger(
              selecionado
            ) ||
            !dias.some(
              item =>
                item.dia ===
                selecionado
            )
          ) {
            diaVencimentoMensalidadeRenovacao.value =
              '';
          }
        }

        atualizarPrimeiroVencimentoManaged();

        return (
          dias.length >
          0
        );
      } catch (error) {
        if (
          seq !==
          sequenciaCargaPoliticaCobranca
        ) {
          return false;
        }

        diasVencimentoCobranca.value = [];
        politicaCobrancaAplicavelId.value = null;
        diaVencimentoHerdadoFrontend.value = false;

        erroPoliticaCobranca.value =
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          'Não foi possível carregar os dias de vencimento da política aplicável.';

        if (
          renovacaoManagedAtiva.value
        ) {
          mensalidade.primeiro_vencimento =
            '';
        }

        return false;
      } finally {
        if (
          seq ===
          sequenciaCargaPoliticaCobranca
        ) {
          carregandoDiasVencimentoCobranca.value =
            false;
        }
      }
    };


    const limparPreviewRenovacaoManaged = () => {
      sequenciaPreviewRenovacaoManaged +=
        1;

      previewRenovacaoManaged.value =
        null;

      erroPreviewRenovacaoManaged.value =
        '';

      carregandoPreviewRenovacaoManaged.value =
        false;
    };


    const carregarPreviewRenovacaoManaged = async () => {
      if (
        !renovacaoManagedAtiva.value
      ) {
        limparPreviewRenovacaoManaged();
        return false;
      }

      const matriculaId =
        Number(
          props.planoAtual?.id
        );

      const regulares =
        parcelasRegularesRenovacao();

      const primeira =
        regulares[0];

      const dia =
        Number(
          diaVencimentoMensalidadeRenovacao.value
        );

      const formaId =
        Number(
          primeira?.forma_pagamento_id
        );

      const contaId =
        Number(
          primeira?.conta_financeira_id
        );

      const politicaId =
        Number(
          politicaCobrancaAplicavelId.value
        );

      if (
        !Number.isInteger(matriculaId) ||
        matriculaId <= 0 ||
        !planoNovo.inicio_vigencia ||
        !planoNovo.categoria_id ||
        !planoNovo.tipo_plano_id ||
        !Number.isInteger(dia) ||
        !diasVencimentoCobranca.value.some(
          item =>
            item.dia === dia
        ) ||
        !Number.isInteger(formaId) ||
        formaId <= 0 ||
        !isBoletoSemantico(formaId) ||
        !Number.isInteger(contaId) ||
        contaId <= 0 ||
        !Number.isInteger(politicaId) ||
        politicaId <= 0 ||
        carregandoDiasVencimentoCobranca.value ||
        !!erroPoliticaCobranca.value
      ) {
        limparPreviewRenovacaoManaged();
        return false;
      }

      const valorMensalBruto =
        normalizarMoedaContratualTexto(
          mensalidadeValorInput.value ||
          mensalidade.valor
        );

      const descontoMensalidadePercentual =
        normalizarPercentualContratualTexto(
          mensalidade.desconto
        );

      if (
        !valorMensalBruto ||
        descontoMensalidadePercentual ===
          null
      ) {
        limparPreviewRenovacaoManaged();
        return false;
      }

      const requisicao =
        ++sequenciaPreviewRenovacaoManaged;

      carregandoPreviewRenovacaoManaged.value =
        true;

      erroPreviewRenovacaoManaged.value =
        '';

      try {
        const { data } =
          await axios.post(
            '/operacional/matriculas/mensalidade-managed/preview',
            {
              matricula_id:
                matriculaId,

              inicio_vigencia:
                planoNovo.inicio_vigencia,

              categoria_id:
                Number(
                  planoNovo.categoria_id
                ),

              tipo_plano_id:
                Number(
                  planoNovo.tipo_plano_id
                ),

              dia_vencimento_mensalidade:
                dia,

              mensalidade_forma_pagamento_id:
                formaId,

              mensalidade_conta_financeira_id:
                contaId,

              encerrar_vigencia_final_ano:
                planoNovo
                  .encerrar_vigencia_final_ano ===
                true,

              valor_mensalidade:
                valorMensalBruto,

              desconto_mensalidade:
                descontoMensalidadePercentual
            }
          );

        if (
          requisicao !==
          sequenciaPreviewRenovacaoManaged
        ) {
          return false;
        }

        if (
          String(
            data?.tipo_preview ||
            ''
          ).toUpperCase() !==
            'RENOVACAO' ||
          Number(
            data?.matricula_id
          ) !==
            matriculaId ||
          Number(
            data?.politica_cobranca_id
          ) !==
            politicaId ||
          Number(
            data?.dia_vencimento_mensalidade
          ) !==
            dia ||
          !Array.isArray(
            data?.obrigacoes
          ) ||
          data.obrigacoes.length ===
            0
        ) {
          throw new Error(
            'O backend retornou uma prévia de renovação inconsistente.'
          );
        }

        previewRenovacaoManaged.value =
          data;

        if (
          data
            ?.primeiro_vencimento_regular
        ) {
          mensalidade.primeiro_vencimento =
            data
              .primeiro_vencimento_regular;
        }

        const quantidade =
          Number(
            data
              ?.quantidade_pagamentos
          );

        if (
          Number.isInteger(
            quantidade
          ) &&
          quantidade > 0
        ) {
          mensalidade.quantidade_pagamentos =
            quantidade;
        }

        if (
          data
            ?.resumo
            ?.total_contratual
        ) {
          mensalidade.valor_total =
            data
              .resumo
              .total_contratual;
        }

        if (
          data
            ?.dia_vencimento_herdado ===
          true
        ) {
          diaVencimentoHerdadoFrontend.value =
            true;
        }

        const adicionais =
          (mensalidade.pagamentos || [])
            .filter(
              pagamento =>
                pagamento?.adicional ===
                  true
            );

        const regularesAtuais =
          parcelasRegularesRenovacao();

        const regularesPreview =
          data.obrigacoes.map(
            (obrigacao, index) => {
              const atual =
                regularesAtuais[index] ||
                {};

              return {
                ...atual,

                forma_pagamento_id:
                  formaId,

                conta_financeira_id:
                  contaId,

                data_vencimento:
                  obrigacao
                    .data_vencimento,

                valor:
                  globalUtils
                    .formatarValor(
                      Number(
                        obrigacao.valor
                      )
                    ),

                data_pagamento:
                  null,

                data_recebimento:
                  null,

                numero_autorizacao:
                  null,

                adicional:
                  false,

                _preview_managed:
                  true,

                _preview_numero_parcela:
                  obrigacao
                    .numero_parcela ??
                  null,

                _preview_composicoes:
                  Array.isArray(
                    obrigacao
                      .composicoes
                  )
                    ? obrigacao
                        .composicoes
                    : []
              };
            }
          );

        mensalidade.pagamentos = [
          ...regularesPreview,
          ...adicionais
        ];

        return true;
      } catch (error) {
        if (
          requisicao !==
          sequenciaPreviewRenovacaoManaged
        ) {
          return false;
        }

        previewRenovacaoManaged.value =
          null;

        erroPreviewRenovacaoManaged.value =
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          error?.message ||
          'Não foi possível calcular a prévia financeira da renovação.';

        return false;
      } finally {
        if (
          requisicao ===
          sequenciaPreviewRenovacaoManaged
        ) {
          carregandoPreviewRenovacaoManaged.value =
            false;
        }
      }
    };


    const mensagemPreviewProrataRenovacaoManaged =
      computed(
        () => {
          const preview =
            previewRenovacaoManaged.value;

          if (!preview) {
            return '';
          }

          const prorata =
            preview.prorata;

          if (
            !prorata ||
            String(
              prorata.valor ||
              '0.00'
            ) ===
              '0.00'
          ) {
            return 'Não há pró-rata a acrescentar à competência inicial desta renovação.';
          }

          const diasAtivos =
            Number(
              prorata.dias_ativos
            );

          const diasCompetencia =
            Number(
              prorata.dias_competencia
            );

          const diasTexto =
            Number.isFinite(
              diasAtivos
            ) &&
            Number.isFinite(
              diasCompetencia
            )
              ? ` (${diasAtivos} de ${diasCompetencia} dias)`
              : '';

          const inicio =
            globalUtils
              .formatarData(
                preview.data_inicio
              );

          const modo =
            String(
              prorata.modo ||
              ''
            ).toUpperCase();

          const destino =
            modo ===
              'ACUMULAR_PROXIMA_PARCELA'
              ? ' O valor será acumulado à primeira mensalidade.'
              : (
                  modo ===
                    'PRIMEIRA_PARCELA'
                    ? ' O valor será cobrado em título próprio antes das mensalidades integrais.'
                    : ''
                );

          return (
            `Pró-rata aplicado: ${globalUtils.formatarValor(
              prorata.valor
            )} referente à competência inicial a partir de ${inicio}${diasTexto}.${destino}`
          );
        }
      );


    const primeiroTituloPreviewRenovacaoManaged =
      computed(
        () =>
          previewRenovacaoManaged.value
            ?.obrigacoes
            ?.[0] ||
          null
      );


    const editablePlano = reactive({ ...props.planoAtual, conta_financeira_id: "", valor: null, valor_com_desconto: null })

    if (editablePlano.numero_autorizacao === undefined) editablePlano.numero_autorizacao = '';
    if (editablePlano.direito_imagem === undefined) editablePlano.direito_imagem = props.planoAtual?.direito_imagem ?? null;

    // Normaliza valor para boolean (aceita true/false, 'true'/'false', 't'/'f', 1/0, '1'/'0')
    const coerceBool = (v) => {
      if (v === true || v === false) return v;
      if (v === 'true' || v === 't' || v === 1 || v === '1') return true;
      if (v === 'false' || v === 'f' || v === 0 || v === '0') return false;
      return v === null || v === undefined ? null : !!v;
    };
    // Preenche com valor atual da matrícula (se existir) e converte para boolean
    if (editablePlano.direito_imagem !== null && editablePlano.direito_imagem !== undefined) {
      editablePlano.direito_imagem = coerceBool(editablePlano.direito_imagem);
    } else if (props.planoAtual && typeof props.planoAtual.direito_imagem !== 'undefined') {
      editablePlano.direito_imagem = coerceBool(props.planoAtual.direito_imagem);
    } else {
      editablePlano.direito_imagem = null;
    }

    const isSaving = ref(false);

    const isEspecie = formaId => {
      const forma = formasPagamento.value.find(f => f.id === formaId);
      return forma?.nome === 'Espécie';
    };

    const isAInformar = formaId => {
      const forma = formasPagamento.value.find(f => f.id === formaId);
      return forma?.nome === 'A informar';
    };

    const contasFinanceiras = ref([]);
    const carregarContasFinanceiras = async () => {
      try {
        const response = await axios.get('/financeiro/contas-financeiras/selecao-operacional', { params: { fluxo: 'renovacao' } });
        contasFinanceiras.value = response.data.data || response.data;
      } catch (error) {
        console.error("❌ Erro ao carregar contas financeiras:", error);
      }
    };

    // Funções para carregar dados via API
    const carregarCategorias = async () => {
      try {
        const response = await axios.get('/cadastros/categorias-de-planos');
        const data = response.data.data || response.data;
        categorias.value = Array.isArray(data) ? data.filter(c => c.ativo) : [];
      } catch (error) {
        console.error("Erro ao carregar categorias:", error);
      }
    };

    const carregarTiposPlano = async () => {
      if (!planoNovo.categoria_id) return;
      try {
        // 1) Planos de matrícula da categoria (pega tudo)
        const responsePlanos = await axios.get('/cadastros/planos-matriculas', {
          params: {
            categoria_id: planoNovo.categoria_id,
            page: 1,
            limit: 10000
          }
        });
        const planosArray = responsePlanos.data?.data || responsePlanos.data || [];
        const planosAtivos = Array.isArray(planosArray)
          ? planosArray.filter(plano => ('ativo' in plano) ? (plano.ativo === true || plano.ativo === 1) : true)
          : [];

        // 2) Tipos de planos (pega tudo, ordenado por duração)
        const responseTipos = await axios.get('/cadastros/tipos-planos', {
          params: {
            page: 1,
            limit: 10000,
            sort: 'duracao',
            order: 'asc'
          }
        });
        const tiposPlanosLista = responseTipos.data?.data || responseTipos.data || [];

        // 3) Mapeia e casa pelo nome
        const lista = planosAtivos.map(plano => {
          const tipoEncontrado = tiposPlanosLista.find(
            tipo => (tipo?.nome || '').trim() === (plano?.tipo || '').trim()
          );
          return {
            id: tipoEncontrado ? tipoEncontrado.id : null,
            nome: plano?.tipo || '',
            duracao: tipoEncontrado?.duracao ?? null,
            aulas_semana: plano?.aulas_semana ?? 0,
            quantidade_parcelas: plano?.quantidade_parcelas ?? 0,
            valor_mensalidade: plano?.valor_parcela ?? 0
          };
        }).filter(t => t.id !== null);

        // 4) Ordenação por duração (fallback seguro)
        lista.sort((a, b) => {
          const da = Number.isFinite(a.duracao) ? a.duracao : Number.MAX_SAFE_INTEGER;
          const db = Number.isFinite(b.duracao) ? b.duracao : Number.MAX_SAFE_INTEGER;
          return da - db;
        });

        tiposPlano.value = lista;

        // 5) Mantém auto-preenchimento se já houver tipo selecionado
        if (planoNovo.tipo_plano_id) {
          const planoSelecionado = tiposPlano.value.find(p => p.id === planoNovo.tipo_plano_id);
          if (planoSelecionado) {
            planoNovo.aulas_semana = planoSelecionado.aulas_semana;
            planoNovo.quantidade_parcelas = planoSelecionado.quantidade_parcelas;
            mensalidade.quantidade_pagamentos = planoNovo.quantidade_parcelas;
            mensalidade.valor = planoSelecionado.valor_mensalidade;
            calcularValorComDescontoMensalidade();
            if (planoNovo.inicio_vigencia) calcularTerminoVigencia();
          }
        }
      } catch (error) {
        console.error("Erro ao carregar tipos de plano:", error?.response?.data || error);
      }
    };

    const handleTipoPlanoChange = async () => {
      await carregarTiposPlano();
      // se ainda não há início e a matrícula está vigente, preenche com D+1 do término atual
      if (!planoNovo.inicio_vigencia && isPlanoVigente() && props.planoAtual?.termino_vigencia) {
        planoNovo.inicio_vigencia = addDaysISO(props.planoAtual.termino_vigencia, 1);
      }
      // se já há início, calcula término imediatamente
      if (planoNovo.inicio_vigencia) {
        calcularTerminoVigencia();
      }
      if (planoNovo.encerrar_vigencia_final_ano) {
        aplicarEncerramentoFinalAno();
      }
    };


    const carregarNiveis = async () => {
      try {
        const { data } = await axios.get('/cadastros/niveis-turmas', {
          params: { page: 1, limit: 10000 }
        });
        const lista = data?.data ?? data ?? [];
        niveis.value = Array.isArray(lista) ? lista.filter(n => n.ativo) : [];
      } catch (error) {
        console.error("Erro ao carregar níveis:", error);
        niveis.value = [];
      }
    };

    const contarPagamentosAteTermino = (primeiroVencimento, terminoVigencia) => {
      if (!primeiroVencimento || !terminoVigencia) return 0;

      const inicio = new Date(`${primeiroVencimento}T00:00:00`);
      const fim = new Date(`${terminoVigencia}T00:00:00`);

      if (Number.isNaN(inicio.getTime()) || Number.isNaN(fim.getTime())) return 0;
      if (inicio > fim) return 0;

      let count = 0;
      const cursor = new Date(inicio);

      while (cursor <= fim) {
        count++;
        cursor.setMonth(cursor.getMonth() + 1);
      }

      return count;
    };

    const aplicarQuantidadePagamentosAteTermino = () => {
      const dataBase =
        mensalidade.primeiro_vencimento ||
        planoNovo.inicio_vigencia;

      const qtd = contarPagamentosAteTermino(
        dataBase,
        planoNovo.termino_vigencia
      );

      if (!qtd) return;

      planoNovo.quantidade_parcelas = qtd;
      mensalidade.quantidade_pagamentos = qtd;

      calcularBasicosMensalidade();

      if (!mensalidade.primeiro_vencimento && planoNovo.inicio_vigencia) {
        mensalidade.primeiro_vencimento = planoNovo.inicio_vigencia;
      }

      if (mensalidade.primeiro_vencimento) {
        remontarParcelasSemRecalcularTotal();
      }
    };

    const aplicarEncerramentoFinalAno = () => {
      if (!planoNovo.inicio_vigencia) return;

      const ano = String(planoNovo.inicio_vigencia).slice(0, 4);
      if (!ano || ano.length !== 4) return;

      planoNovo.termino_vigencia = `${ano}-12-31`;

      if (!mensalidade.primeiro_vencimento) {
        mensalidade.primeiro_vencimento = planoNovo.inicio_vigencia;
      }

      aplicarQuantidadePagamentosAteTermino();
    };

    const aplicarQuantidadeParcelasDoPlano = () => {
      const planoSelecionado = tiposPlano.value.find(
        p => Number(p.id) === Number(planoNovo.tipo_plano_id)
      );

      if (!planoSelecionado) return;

      planoNovo.quantidade_parcelas = planoSelecionado.quantidade_parcelas;
      mensalidade.quantidade_pagamentos = planoSelecionado.quantidade_parcelas;

      calcularBasicosMensalidade();

      if (mensalidade.primeiro_vencimento) {
        remontarParcelasSemRecalcularTotal();
      }
    };

    const onEncerrarFinalAnoChange = () => {
      if (planoNovo.encerrar_vigencia_final_ano) {
        aplicarEncerramentoFinalAno();
        return;
      }

      calcularTerminoVigencia();
      aplicarQuantidadeParcelasDoPlano();
    };

    // Calcular Término da Vigência e atualizar campos não editáveis
    const calcularTerminoVigencia = () => {
      if (planoNovo.encerrar_vigencia_final_ano) {
        aplicarEncerramentoFinalAno();
        return;
      }

      const planoSelecionado = tiposPlano.value.find(
        p => Number(p.id) === Number(planoNovo.tipo_plano_id)
      );

      if (planoSelecionado && planoNovo.inicio_vigencia) {
        const inicio = new Date(planoNovo.inicio_vigencia + 'T00:00:00');

        inicio.setDate(inicio.getDate() + Number(planoSelecionado.duracao || 0));

        planoNovo.termino_vigencia = inicio.toISOString().split('T')[0];
        planoNovo.aulas_semana = planoSelecionado.aulas_semana;
        planoNovo.quantidade_parcelas = planoSelecionado.quantidade_parcelas;
        mensalidade.quantidade_pagamentos = planoNovo.quantidade_parcelas;

        calcularBasicosMensalidade();

        if (mensalidade.primeiro_vencimento) {
          remontarParcelasSemRecalcularTotal();
        }
      }
    };

    function iso(dateStr){ return dateStr ? new Date(dateStr + 'T00:00:00') : null }

    function isPlanoVigente() {
      const ini = iso(props.planoAtual?.inicio_vigencia)
      const fim = iso(props.planoAtual?.termino_vigencia)
      if (!ini || !fim) return false
      const hoje = new Date(); hoje.setHours(0,0,0,0)
      return (hoje >= ini && hoje <= fim) // vigente = hoje entre início e término (inclusive)
    }

    function addDaysISO(dateStr, days = 1) {
      if (!dateStr) return ''
      const d = new Date(dateStr + 'T00:00:00')
      d.setDate(d.getDate() + days)
      return d.toISOString().split('T')[0]
    }

    // 3️⃣ Calcula data_pagamento: crédito +30d, débito +1d, depois próximo dia útil
    function calcularDataPagamento(vencimentoIso, formaId) {
      const forma = formasPagamento.value.find(f => f.id === formaId);
      if (!forma || !vencimentoIso) return '';

      const nome = (forma.nome || '').toLowerCase();
      const dias =
        nome.includes('crédito') ? 30 :
        nome.includes('débito')   ? 1  :
        (Number(forma.prazo_pagamento) || 0);

      const d0 = new Date(`${vencimentoIso}T00:00:00`);
      d0.setDate(d0.getDate() + dias);

      // empurra para dia útil com regra centralizada (fds + feriados)
      return globalUtils.nextBusinessDay(d0).toISOString().slice(0, 10);
    }

    function calcularDataRecebimento(dataBaseIso, formaId, numeroParcela = 1) {
      if (!dataBaseIso || !formaId) return null;

      return globalUtils.calcularDataRecebimento(
        dataBaseIso,
        formaId,
        formasPagamento.value,
        numeroParcela
      ) || null;
    }

    const recalcularRecebimentoParcelaMensal = (p) => {
      const formaId = p?.forma_pagamento_id;

      if (!formaId || isAInformar(formaId)) {
        p.data_recebimento = null;
        return;
      }

      if (isCartaoCreditoParcelado(formaId)) {
        const numeroParcela = getNumeroParcelaNoBlocoParcelado(p);
        const dataBaseOperacao = getDataBaseBlocoParcelado(p);

        if (!dataBaseOperacao) {
          p.data_recebimento = null;
          return;
        }

        p.data_recebimento = calcularDataRecebimento(
          dataBaseOperacao,
          formaId,
          numeroParcela
        );
        return;
      }

      if (!p?.data_pagamento) {
        p.data_recebimento = null;
        return;
      }

      p.data_recebimento = calcularDataRecebimento(
        p.data_pagamento,
        formaId,
        1
      );
    };

    const recalcularRecebimentoBlocoParcelado = (pag) => {
      const bloco = getBlocoParceladoDaParcela(pag);
      if (!bloco.length) return;

      const primeira = bloco[0];

      if (!primeira.data_pagamento) {
        primeira.data_pagamento = primeira.data_vencimento || null;
      }

      const dataBaseOperacao = getDataBaseBlocoParcelado(primeira);

      bloco.forEach((p, idx) => {
        if (!p.data_pagamento) {
          p.data_pagamento = p.data_vencimento || null;
        }

        if (!dataBaseOperacao) {
          p.data_recebimento = null;
          return;
        }

        p.data_recebimento = calcularDataRecebimento(
          dataBaseOperacao,
          p.forma_pagamento_id,
          idx + 1
        );
      });
    };

    watch(
      () => [editablePlano.forma_pagamento_id, editablePlano.data_vencimento],
      ([formaId, venc]) => {
        if (!formaId) {
          editablePlano.data_pagamento   = null;
          editablePlano.data_recebimento = null;
          return;
        }
        if (isAInformar(formaId)) {
          editablePlano.data_pagamento      = null;
          editablePlano.data_recebimento    = null;
          return;
        }

        // ★ NOVO: no momento do preenchimento
        editablePlano.data_pagamento = venc || null;

        editablePlano.data_recebimento = (editablePlano.data_pagamento)
          ? calcularDataRecebimento(editablePlano.data_pagamento, formaId)
          : null;
      },
      { immediate: true }
    );

    // Sempre que o usuário editar data_pagamento do editablePlano, recalcule o recebimento
    watch(
      () => [editablePlano.forma_pagamento_id, editablePlano.data_pagamento],
      ([formaId, dataPgto]) => {
        if (!formaId || isAInformar(formaId) || !dataPgto) {
          editablePlano.data_recebimento = null;
          return;
        }
        editablePlano.data_recebimento = calcularDataRecebimento(dataPgto, formaId);
      }
    );

    /*
     * O watcher automático existe para sanear parcelas criadas
     * pelo fluxo legacy quando a forma de pagamento muda.
     *
     * Não usamos Array como retorno da source: a substituição da
     * grade pelo preview managed criaria uma nova referência mesmo
     * quando todas as formas permanecessem iguais.
     *
     * Linhas devolvidas pelo backend com _preview_managed também
     * não precisam passar novamente pelo saneamento automático.
     * Alterações feitas pelo usuário continuam atendidas pelo
     * @change="onPagamentoFormaChange(p)" do próprio select.
     */
    const assinaturaFormasPagamentosMensalidade =
      () =>
        (mensalidade.pagamentos || [])
          .map(
            p =>
              String(
                p?.forma_pagamento_id ??
                ''
              )
          )
          .join('|');

    watch(
      assinaturaFormasPagamentosMensalidade,
      () => {
        (mensalidade.pagamentos || [])
          .forEach(
            p => {
              if (
                p?._preview_managed ===
                true
              ) {
                return;
              }

              onPagamentoFormaChange(
                p
              );
            }
          );
      },
      { immediate: true }
    );

    // Watchers para recarregar dados conforme seleção do usuário
    watch(() => planoNovo.categoria_id, async (novaCategoria) => {
      if (novaCategoria) {
        await carregarTiposPlano();
      }
    });

    // ✅ ao mudar nível base, só garante slots e nivel_id nas linhas (não filtra turmas no front)
    const onNivelBaseChange = async () => {
      const nivelPadrao = Number(planoNovo.nivel_id) || null;
      planoNovo.turmas = (planoNovo.turmas || []).map(l => ({
        ...l,
        nivel_id: (l && l.nivel_id != null) ? Number(l.nivel_id) : nivelPadrao
      }));
    };

    const onNivelLinhaChange = (index) => {
      const linha = planoNovo.turmas[index];
      if (!linha) return;
      linha.turma_id = '';
      linha.id = null;
      linha.dia = '';
      linha.horario = '';
      linha.instrutor = '';
      linha.turma_completa = '';
    };

    // Watcher para disparar a distribuição das parcelas assim que o 1º vencimento for informado
    watch(() => mensalidade.primeiro_vencimento, (nova) => {
      if (!nova) return;

      if (
        renovacaoManagedAtiva.value
      ) {
        return;
      }

      if (planoNovo.encerrar_vigencia_final_ano) {
        aplicarQuantidadePagamentosAteTermino();
        return;
      }

      remontarParcelasSemRecalcularTotal();
    });

    watch(
      () => planoNovo.inicio_vigencia,
      async () => {
        await carregarDiasVencimentoRenovacao();

        if (
          renovacaoManagedAtiva.value
        ) {
          atualizarPrimeiroVencimentoManaged();
        }
      }
    );

    watch(
      () => renovacaoManagedAtiva.value,
      async (ativa) => {
        if (!ativa) {
          return;
        }

        await carregarDiasVencimentoRenovacao();
        atualizarPrimeiroVencimentoManaged();
      }
    );


    /*
     * Cada dependência é observada separadamente.
     *
     * carregarPreviewRenovacaoManaged() substitui
     * mensalidade.pagamentos pela grade devolvida pelo backend.
     * Um getter que retornasse um novo Array de dependências
     * poderia se reacionar somente pela troca da referência da
     * grade, mesmo sem mudança de forma/conta.
     *
     * No formato multi-source, Vue compara os valores de cada
     * fonte e evita esse ciclo quando os valores permanecem iguais.
     */
    watch(
      [
        () =>
          renovacaoManagedAtiva.value,

        () =>
          planoNovo.inicio_vigencia,

        () =>
          planoNovo.categoria_id,

        () =>
          planoNovo.tipo_plano_id,

        () =>
          planoNovo.encerrar_vigencia_final_ano,

        () =>
          diaVencimentoMensalidadeRenovacao.value,

        () =>
          mensalidade.valor,

        () =>
          mensalidade.desconto,

        () =>
          parcelasRegularesRenovacao()[0]
            ?.forma_pagamento_id ??
          null,

        () =>
          parcelasRegularesRenovacao()[0]
            ?.conta_financeira_id ??
          null,

        () =>
          politicaCobrancaAplicavelId.value,

        () =>
          carregandoDiasVencimentoCobranca.value,

        () =>
          erroPoliticaCobranca.value
      ],
      () => {
        if (
          !renovacaoManagedAtiva.value
        ) {
          limparPreviewRenovacaoManaged();
          return;
        }

        void carregarPreviewRenovacaoManaged();
      }
    );

    // WatchEffect para inicializar o array de turmas quando ambos os campos estiverem preenchidos
    watchEffect(() => {
      if (
        planoNovo.nivel_id &&
        planoNovo.aulas_semana &&
        planoNovo.turmas.length === 0  // somente inicializa se o array estiver vazio
      ) {
        const qtd = Number(planoNovo.aulas_semana) || 0;
        const nivelPadrao = Number(planoNovo.nivel_id) || null;

        planoNovo.turmas = Array.from({ length: qtd }, () => ({
          nivel_id: nivelPadrao,
          turma_id: '',
          id: null,
          dia: "",
          horario: "",
          instrutor: "",
          turma_completa: ""
        }));
      }
    });

    // sempre que mensalidade.valor mudar por código (tipo de plano etc), atualiza o input (se o usuário não estiver digitando)
    watch(
      () => mensalidade.valor,
      (v) => {
        if (isEditingMensalidadeValor.value) return
        mensalidadeValorInput.value = globalUtils.formatarValor(v || 0)
      },
      { immediate: true }
    )

    // quando o usuário editar desconto (sem benefício), remonta parcelas
    watch(() => mensalidade.desconto, () => {
      // não recalcula valor_total automaticamente quando o usuário altera desconto
      // (se desconto vier do benefício, o sistema já mexe no fluxo por outro caminho)
    });

    // Funções para manipular turmas
    const adicionarTurma = () => {
      const nivelPadrao = Number(planoNovo.nivel_id) || null;
      planoNovo.turmas.push({ nivel_id: nivelPadrao, turma_id: '' });
    };

    const removerTurma = (index) => {
      planoNovo.turmas.splice(index, 1);
    };

    const completarTurmas = () => {
      return (planoNovo.turmas || []).map(linha => {
        const raw = String(linha?.turma_id || '').trim();
        const nivelIdLinha = Number(linha?.nivel_id ?? planoNovo.nivel_id) || null;

        if (!raw) {
          return { ...linha, nivel_id: nivelIdLinha, turma_id: null, horario: null, turma_completa: "Não informado" };
        }

        // raw: "ID-DIA-HH:MM:SS"
        const id = Number(raw.split('-')[0] || 0) || null;
        const resto = raw.substring(raw.indexOf('-') + 1);
        const lastHyphen = resto.lastIndexOf('-');
        const dia = lastHyphen >= 0 ? resto.substring(0, lastHyphen) : '';
        const horario = lastHyphen >= 0 ? resto.substring(lastHyphen + 1) : '';

        const base = turmasDisponiveisPorNivel(nivelIdLinha || planoNovo.nivel_id);
        const tComp = base.find(t =>
          Number(t.id) === Number(id) && String(t.dia) === String(dia) && String(t.horario) === String(horario)
        );

        if (!tComp) {
          return { ...linha, nivel_id: nivelIdLinha, turma_id: id, dia, horario, instrutor: '', turma_completa: "Não informado" };
        }

        return {
          ...linha,
          nivel_id: nivelIdLinha,
          id: tComp.id,
          turma_id: Number(tComp.id),
          dia: tComp.dia,
          horario: tComp.horario,
          instrutor: tComp.instrutor,
          turma_completa: `Turma: ${tComp.id} | Dia: ${tComp.dia} | Hora: ${String(tComp.horario || '').slice(0,5)} | Instrutor: ${tComp.instrutor}`
        };
      });
    };

    const atualizarTurma = (index) => {
      const linha = planoNovo.turmas[index];
      if (!linha) return;

      // exige nível por linha
      if (!linha.nivel_id) {
        alert("Selecione o nível desta linha antes de escolher a turma.");
        linha.turma_id = '';
        return;
      }

      const raw = String(linha.turma_id || '').trim();
      if (!raw) return;

      const id = raw.split('-')[0];
      const resto = raw.substring(raw.indexOf('-') + 1);
      const lastHyphen = resto.lastIndexOf('-');
      if (lastHyphen === -1) {
        linha.turma_id = '';
        return;
      }
      const dia = resto.substring(0, lastHyphen);
      const horario = resto.substring(lastHyphen + 1);

      const base = turmasDisponiveisPorNivel(linha.nivel_id || planoNovo.nivel_id);
      const tComp = base.find(t =>
        String(t.id) === String(id) && String(t.dia) === String(dia) && String(t.horario) === String(horario)
      );

      if (!tComp) {
        planoNovo.turmas[index] = { ...linha, id: null, dia: '', horario: '', instrutor: '', turma_completa: 'Não informado' };
        return;
      }

      // valida choque dia/horário com outra linha (independente do nível)
      if (hasChoqueComOutraLinha(tComp.dia, tComp.horario, index)) {
        alert(`Conflito: já existe turma em "${tComp.dia}" às "${String(tComp.horario).slice(0,5)}" em outra linha.`);
        linha.turma_id = '';
        return;
      }

      planoNovo.turmas[index] = {
        ...linha,
        id: tComp.id,
        dia: tComp.dia,
        horario: tComp.horario,
        instrutor: tComp.instrutor,
        turma_completa: `Turma: ${tComp.id} | Dia: ${tComp.dia} | Hora: ${String(tComp.horario || '').slice(0,5)} | Instrutor: ${tComp.instrutor}`
      };
    };

    const recalcularParcelas = () => {
      // Filtra apenas os pagamentos normais (não adicionais)
      const pagamentosNormais = mensalidade.pagamentos.filter(p => !p.adicional);

      const parcelasPagas = pagamentosNormais.filter(p => p.data_pagamento && p.data_pagamento.trim() !== "").length;
      const parcelasRestantes = pagamentosNormais.length - parcelasPagas;
      if (parcelasRestantes <= 0) return;

      let valorTotalRestante = parseFloat(mensalidade.valor_total) || 0;

      pagamentosNormais.forEach(p => {
        if (p.data_pagamento && p.data_pagamento.trim() !== "") {
          let valorNumerico = parseFloat(p.valor.toString().replace(/[^\d.,-]/g, "").replace(",", "."));
          if (!isNaN(valorNumerico)) {
            valorTotalRestante -= valorNumerico;
          }
        }
      });

      const novoValorParcela = +(valorTotalRestante / parcelasRestantes).toFixed(2);
      pagamentosNormais.forEach(p => {
        if (!p.data_pagamento || p.data_pagamento.trim() === "") {
          p.valor = novoValorParcela;  // <<< número, não string
        }
      });

      // Atualiza vencimentos apenas para os pagamentos normais que já possuem data definida,
      // deixando em branco os campos das novas parcelas (que o usuário preencherá manualmente)
      let dataBase;
      const pagamentosPagos = pagamentosNormais.filter(p => p.data_pagamento && p.data_pagamento.trim() !== "");
      if (pagamentosPagos.length > 0) {
        pagamentosPagos.sort((a, b) => new Date(a.data_vencimento) - new Date(b.data_vencimento));
        dataBase = new Date(pagamentosPagos[pagamentosPagos.length - 1].data_vencimento);
        dataBase.setMonth(dataBase.getMonth() + 1);
      } else if (mensalidade.primeiro_vencimento) {
        dataBase = new Date(mensalidade.primeiro_vencimento);
      } else {
        return;
      }

      const parcelasNaoPagas = pagamentosNormais.filter(p => !p.data_pagamento || p.data_pagamento.trim() === "");
      parcelasNaoPagas.forEach((p, index) => {
        // Se já houver data preenchida, atualize; senão, deixe em branco
        if (p.data_vencimento && p.data_vencimento.trim() !== "") {
          let novaData = new Date(dataBase);
          novaData.setMonth(novaData.getMonth() + index);
          p.data_vencimento = novaData.toISOString().split("T")[0];
        }
      });
    };


    // Funções para manipular pagamentos
    const adicionarPagamento = () => {
      mensalidade.pagamentos.push({
        forma_pagamento_id: '',
        data_vencimento: '',
        valor: mensalidade.valor_com_desconto,
        data_pagamento: null,
        data_recebimento: null,
        adicional: false,
        conta_financeira_id: null,
        banco_numero: "",
        agencia: "",
        cheque_numero: "",
        numero_autorizacao: null
      });
      recalcularParcelas();
    };

    const removerPagamento = (index) => {
      const pagamento = mensalidade.pagamentos[index];

      // Não permite remover um pagamento que já foi quitado
      if (pagamento.data_pagamento && pagamento.data_pagamento.trim() !== "") {
        alert("❌ Não é possível excluir um pagamento que já foi quitado.");
        return;
      }

      // Verifica se há mais de uma parcela não paga
      const naoPagos = mensalidade.pagamentos.filter(p =>
        !p.data_pagamento || p.data_pagamento.trim() === ""
      );

      if (naoPagos.length === 1) {
        alert("⚠️ Não é possível excluir a última parcela não paga.");
        return;
      }

      // Remove o pagamento e recalcula as parcelas restantes
      mensalidade.pagamentos.splice(index, 1);
      recalcularParcelas();
    };

    // Função para formatação de valores
    const formatarValor = (valor) => {
      return globalUtils.formatarValor(valor);
    };

    // Função para calcular Valor com Desconto da Mensalidade
    const calcularValorComDescontoMensalidade = () => {
      calcularBasicosMensalidade(); // só atualiza valor_com_desconto e valor_total
      // nada de remontar aqui — o watcher de "mensalidade.desconto" já chama remontarParcelas()
    };

    // Função para calcular Valor Total da Mensalidade
    const calcularValorTotalMensalidade = () => {
      const valorComDesconto = parseFloat(mensalidade.valor_com_desconto) || 0;
      const qtdPagamentos = parseInt(mensalidade.quantidade_pagamentos) || 0;
      mensalidade.valor_total = (valorComDesconto * qtdPagamentos).toFixed(2);
    };

    // Função para distribuir automaticamente as parcelas na mensalidade
    function distribuirParcelasMensalidade(force = false) {
      if (!mensalidade.primeiro_vencimento) return;

      if (!force && mensalidade.pagamentos.length > 0) return;
      if (force) mensalidade.pagamentos = [];

      let data = new Date(mensalidade.primeiro_vencimento + 'T00:00:00');
      const qtd = parseInt(mensalidade.quantidade_pagamentos) || 0;
      const valorParcela = Number(mensalidade.valor_com_desconto || 0);

      for (let i = 0; i < qtd; i++) {
        const vencISO = data.toISOString().slice(0,10);
        mensalidade.pagamentos.push({
          forma_pagamento_id: '',
          data_vencimento: vencISO,
          valor: valorParcela,
          data_pagamento: null,
          data_recebimento: null,
          adicional: false,
          conta_financeira_id: null,
          banco_numero: "",
          agencia: "",
          cheque_numero: "",
          numero_autorizacao: null
        });
        data.setMonth(data.getMonth() + 1);
      }
      normalizarValoresParcelas();
    }

    // 1) Calcula campos básicos SEM remontar
    function calcularBasicosMensalidade() {
      const valorBase = Number(mensalidade.valor) || 0;
      const desconto  = Number(mensalidade.desconto) || 0;
      mensalidade.valor_com_desconto = Number((valorBase - (valorBase * desconto / 100)).toFixed(2));

      const qtd = parseInt(mensalidade.quantidade_pagamentos) || 0;
      mensalidade.valor_total = Number((mensalidade.valor_com_desconto * qtd).toFixed(2));
    }

    // 2) Descartar e remontar parcelas, SEM recalcular de novo
    function remontarParcelas() {
      if (isRebuilding.value) return;
      isRebuilding.value = true;
      try {
        calcularBasicosMensalidade();       // garante valores corretos
        mensalidade.pagamentos = [];        // zera
        distribuirParcelasMensalidade(true);// monta de novo (ver função abaixo)
        normalizarValoresParcelas();
      } finally {
        isRebuilding.value = false;
      }
    }

    const isCheque = (formaPagamentoId) => {
      const forma = formasPagamento.value.find(fp => fp.id === formaPagamentoId);
      return forma ? forma.nome.toLowerCase() === "cheque" : false;
    };

    const existeCheque = computed(() => {
      return mensalidade.pagamentos.some(p => isCheque(p.forma_pagamento_id));
    });

    const diasAntecedencia = computed(() => {
      const fim = props.planoAtual?.termino_vigencia
      if (!fim) return 0
      const hoje = new Date()
      const baseHoje = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate())
      const fimDt = new Date(fim + 'T00:00:00')
      const diffMs = fimDt - baseHoje
      const dias = Math.ceil(diffMs / (1000 * 60 * 60 * 24))
      return dias > 0 ? dias : 0
    })

    // Benefício por renovação antecipada
    const showBrindeModal = ref(false)
    const beneficio = ref(null)
    // { tipo:'brinde', brindeId, brindeNome, observacao } ou { tipo:'desconto', descontoId, descontoDescricao, descontoPercentual, observacao }

    const descontoSomenteLeitura = computed(() => {
      // Prioriza o que veio do modal
      if (beneficio.value?.tipo === 'desconto') {
        const pct = Number(beneficio.value.descontoPercentual || 0)
        return `${pct.toLocaleString('pt-BR',{minimumFractionDigits:2, maximumFractionDigits:2})}%`
      }
      // fallback: se mensalidade.desconto tiver valor numérico
      const pct = Number(mensalidade.desconto || 0)
      return pct > 0
        ? `${pct.toLocaleString('pt-BR',{minimumFractionDigits:2, maximumFractionDigits:2})}%`
        : ''
    })


    const totalParcelasCalculado = computed(() => {
      const total = (mensalidade.pagamentos || [])
        .filter(p => !p.adicional) // só mensalidades normais
        .reduce((acc, p) => acc + toNumberBR(p.valor), 0);
      return Number(total.toFixed(2));
    });

    const totalParcelasFormatado = computed(() => globalUtils.formatarValor(totalParcelasCalculado.value));

    const totalOficial = computed(() => {
      if (
        renovacaoManagedAtiva.value &&
        previewRenovacaoManaged.value
          ?.resumo
          ?.total_obrigacoes
      ) {
        return Number(
          previewRenovacaoManaged.value
            .resumo
            .total_obrigacoes
        ) || 0;
      }

      return Number(
        mensalidade.valor_total ||
        0
      );
    });

    const totalOficialFormatado =
      computed(
        () =>
          globalUtils.formatarValor(
            totalOficial.value
          )
      );

    const divergenciaTotal = computed(() => {
      // tolerância de 1 centavo para evitar ruído
      return Math.abs(totalParcelasCalculado.value - totalOficial.value) > 0.009;
    });

    const diferencaTotal = computed(() => {
      const diff = totalParcelasCalculado.value - totalOficial.value;
      return Number(diff.toFixed(2));
    });

    const diferencaFormatada = computed(() => {
      return globalUtils.formatarValor(Math.abs(diferencaTotal.value));
    });

    const diferencaLabel = computed(() => {
      if (!divergenciaTotal.value) return '';

      if (diferencaTotal.value < 0) {
        return `Diferença: -${diferencaFormatada.value} (faltando)`;
      } else {
        return `Diferença: +${diferencaFormatada.value} (a mais)`;
      }
    });

    function isRenovacaoAntecipada(){
      const fim = props.planoAtual?.termino_vigencia
      if (!fim) return false
      const today = new Date()
      const limit = new Date(fim + 'T00:00:00')
      limit.setDate(limit.getDate() - 10)
      // hoje <= término - 10 dias
      return today.setHours(0,0,0,0) <= limit.setHours(23,59,59,999)
    }

    function onConfirmBeneficio(payload){
      beneficio.value = payload
      showBrindeModal.value = false
      // Se for desconto por antecipação, aplicar na mensalidade e recalcular
      if (payload?.tipo === 'desconto') {
        mensalidade.desconto = Number(payload.descontoPercentual || 0)
        calcularValorComDescontoMensalidade() // mantém seus cálculos/parcelas
      } else {
        // brinde → não mexe no desconto
        mensalidade.desconto = Number(mensalidade.desconto || 0)
      }
      // opcional: anexar observação automática (sem sobrescrever o que o usuário já escreveu)
      if (payload?.observacao){
        const sep = mensalidade.observacoes ? ' | ' : ''
        mensalidade.observacoes = (mensalidade.observacoes || '') + sep + payload.observacao
      }
    }

    function onCancelBeneficio(){
      // usuário pode fechar o modal e seguir sem benefício (não obrigatório travar)
      showBrindeModal.value = false
    }

    const temNivelMisto = computed(() => {
      const base = Number(planoNovo.nivel_id) || null;
      if (!base) return false;
      return (planoNovo.turmas || []).some(t => t?.nivel_id && Number(t.nivel_id) !== base);
    });

    // Validação do formulário
    const formValid = computed(() => {
      // 1) Validação do plano novo
      const planoValido = Boolean(
        planoNovo.categoria_id &&
        planoNovo.tipo_plano_id &&
        planoNovo.nivel_id &&
        planoNovo.inicio_vigencia &&
        planoNovo.termino_vigencia &&
        planoNovo.aulas_semana &&
        planoNovo.quantidade_parcelas
      );

      // 2) Validação das turmas (✅ nível + turma)
      const minTurmas = Number(planoNovo.aulas_semana || 0);
      const turmasValidas = Array.isArray(planoNovo.turmas) &&
        planoNovo.turmas.length >= minTurmas &&
        planoNovo.turmas.every(t => t.nivel_id && t.turma_id && t.turma_id !== '');

      // 3) Validação da mensalidade e suas parcelas
      const validarPagamentoManual = (p) => {
        const nomeForma =
          formasPagamento.value
            .find(
              f =>
                Number(f.id) ===
                Number(
                  p.forma_pagamento_id
                )
            )
            ?.nome;

        const isAinf =
          nomeForma ===
          'A informar';

        if (
          !p.forma_pagamento_id ||
          !p.data_vencimento
        ) {
          return false;
        }

        if (isAinf) {
          return true;
        }

        if (
          (p.data_pagamento || '').trim() &&
          !p.conta_financeira_id
        ) {
          return false;
        }

        if (
          (nomeForma || '')
            .toLowerCase() ===
            'cheque' &&
          (p.data_pagamento || '').trim()
        ) {
          return Boolean(
            (p.banco_numero || '').trim() &&
            (p.agencia || '').trim() &&
            (p.cheque_numero || '').trim()
          );
        }

        if (
          isFormaComAutorizacao(
            p.forma_pagamento_id
          ) &&
          !(p.numero_autorizacao || '').trim()
        ) {
          return false;
        }

        return true;
      };

      let mensalidadeValida =
        false;

      if (
        renovacaoManagedAtiva.value
      ) {
        const regulares =
          parcelasRegularesRenovacao();

        const primeira =
          regulares[0];

        const formaId =
          Number(
            primeira?.forma_pagamento_id
          );

        const contaId =
          Number(
            primeira?.conta_financeira_id
          );

        const dia =
          Number(
            diaVencimentoMensalidadeRenovacao.value
          );

        const valorCanonico =
          normalizarMoedaContratualTexto(
            mensalidadeValorInput.value ||
            mensalidade.valor
          );

        const descontoCanonico =
          normalizarPercentualContratualTexto(
            mensalidade.desconto
          );

        const mesmaFormaConta =
          regulares.length > 0 &&
          Number.isInteger(
            formaId
          ) &&
          formaId > 0 &&
          Number.isInteger(
            contaId
          ) &&
          contaId > 0 &&
          isBoletoSemantico(
            formaId
          ) &&
          regulares.every(
            p =>
              isBoletoSemantico(
                p.forma_pagamento_id
              ) &&
              Number(
                p.forma_pagamento_id
              ) ===
                formaId &&
              Number(
                p.conta_financeira_id
              ) ===
                contaId
          );

        const diaValido =
          Number.isInteger(
            dia
          ) &&
          diasVencimentoCobranca.value
            .some(
              item =>
                item.dia ===
                dia
            );

        const politicaValida =
          Number.isInteger(
            Number(
              politicaCobrancaAplicavelId.value
            )
          ) &&
          Number(
            politicaCobrancaAplicavelId.value
          ) >
            0 &&
          !erroPoliticaCobranca.value &&
          !carregandoDiasVencimentoCobranca.value;

        const previewValido =
          Boolean(
            previewRenovacaoManaged.value &&
            !carregandoPreviewRenovacaoManaged.value &&
            !erroPreviewRenovacaoManaged.value &&
            Number(
              previewRenovacaoManaged.value
                ?.politica_cobranca_id
            ) ===
              Number(
                politicaCobrancaAplicavelId.value
              ) &&
            Number(
              previewRenovacaoManaged.value
                ?.dia_vencimento_mensalidade
            ) ===
              dia
          );

        const adicionaisValidos =
          (mensalidade.pagamentos || [])
            .filter(
              p =>
                p.adicional
            )
            .every(
              validarPagamentoManual
            );

        mensalidadeValida =
          Boolean(
            valorCanonico &&
            valorCanonico !==
              '0.00' &&
            descontoCanonico &&
            mensalidade.primeiro_vencimento &&
            mesmaFormaConta &&
            diaValido &&
            politicaValida &&
            previewValido &&
            adicionaisValidos
          );
      } else {
        mensalidadeValida =
          Boolean(
            mensalidade.valor &&
            mensalidade.primeiro_vencimento &&
            mensalidade.quantidade_pagamentos &&
            Array.isArray(
              mensalidade.pagamentos
            ) &&
            mensalidade.pagamentos.length >
              0 &&
            mensalidade.pagamentos
              .every(
                validarPagamentoManual
              )
          );
      }

      // 4) Dados da taxa obrigatórios na cobrança automática ou opcional selecionada.
      let financeiroValido = true;
      if (deveCobrarMatricula.value) {
        const formaId = editablePlano.forma_pagamento_id;
        const isAinf = isAInformar(formaId);

        // básicos sempre obrigatórios
        financeiroValido = Boolean(
          editablePlano.valor !== null &&
          editablePlano.data_matricula &&
          editablePlano.forma_pagamento_id &&
          editablePlano.conta_financeira_id &&
          editablePlano.data_vencimento
        );

        if (!isAinf) {
          // cheque com pagamento → exige dados do cheque
          if (isCheque(formaId) && editablePlano.data_pagamento) {
            financeiroValido = financeiroValido &&
              Boolean(
                (editablePlano.banco_numero || '').trim() &&
                (editablePlano.agencia || '').trim() &&
                (editablePlano.cheque_numero || '').trim()
              );
          }
        }

        // Cartão exige autorização
        if (!isAinf && isCartao(formaId)) {
          if (!(editablePlano.numero_autorizacao || '').trim()) {
            financeiroValido = false;
          }
        }

      }

      // 5) Regra do benefício quando for renovação antecipada
      let beneficioValido = true;
      if (isRenovacaoAntecipada()) {
        // precisa ter escolhido algo no modal
        beneficioValido = Boolean(beneficio.value && beneficio.value.tipo && (
          (beneficio.value.tipo === 'brinde' && (beneficio.value.brindeNome || beneficio.value.brindeId !== null)) ||
          (beneficio.value.tipo === 'desconto' && beneficio.value.descontoId)
        ));
      }

      // Resultado final (adicione && brindeValido)
      return planoValido && turmasValidas && mensalidadeValida && financeiroValido && beneficioValido;

    });


    // Função para obter o registro de pós-venda a partir do id da matrícula
    const obterPosvendaPorMatricula = async (matriculaId) => {
      const response = await axios.get('/operacional/posvendas', { params: { matricula_id: matriculaId } });
      if (response.data.data && response.data.data.length > 0) {
        return response.data.data[0];
      }
      throw new Error(`Nenhuma pós-venda encontrada para a matrícula ${matriculaId}`);
    };

    // Registros acessórios da renovação.
    // Não podem impedir a renovação da matrícula.
    // Ex.: alguns perfis não têm acesso ao módulo de Pós-vendas.
    const atualizarPosvendaAposRenovacao = async ({ userName, hojeStr }) => {
      try {
        const posvendaRecord = await obterPosvendaPorMatricula(props.planoAtual.id);

        if (!posvendaRecord?.id) {
          console.warn(
            '⚠️ Pós-venda da matrícula não encontrada. Renovação seguirá normalmente.',
            { matricula_id: props.planoAtual.id }
          );
          return;
        }

        const posvendaId = posvendaRecord.id;

        const historicoPayload = {
          posvenda_id: posvendaId,
          nome_usuario: posvendaRecord.nome_usuario,
          data_contato: posvendaRecord.data_contato || hojeStr,
          descricao: posvendaRecord.descricao,
          proximo_contato: posvendaRecord.proximo_contato
        };

        try {
          await axios.post('/operacional/posvendas/posvendas_historico', historicoPayload);
        } catch (error) {
          console.warn(
            '⚠️ Histórico de pós-venda da renovação não criado. Perfil pode não ter permissão.',
            error?.response?.status,
            error?.response?.data
          );
        }

        const proximoContato = new Date();
        proximoContato.setDate(proximoContato.getDate() + 45);
        const proximoContatoStr = proximoContato.toISOString().split('T')[0];

        const posvendaUpdatePayload = {
          matricula_id: props.planoAtual.id,
          data_contato: hojeStr,
          descricao: `Matrícula renovada em ${hojeStr}`,
          proximo_contato: proximoContatoStr,
          nome_usuario: userName,
          aluno_id: props.planoAtual.aluno_id,
          responsavel_id: props.planoAtual.responsavel_id,
          finalizado: false
        };

        try {
          await axios.put(`/operacional/posvendas/${posvendaId}`, posvendaUpdatePayload);
        } catch (error) {
          console.warn(
            '⚠️ Pós-venda da renovação não atualizada. Perfil pode não ter permissão.',
            error?.response?.status,
            error?.response?.data
          );
        }
      } catch (error) {
        console.warn(
          '⚠️ Pós-venda da renovação não consultada. Perfil pode não ter permissão. Renovação seguirá normalmente.',
          error?.response?.status,
          error?.response?.data
        );
      }
    };

    const renovar = async () => {
      if (isSaving.value) return;
      if (planoNovo.turmas.some(t => !turmaDisponivel(t.turma_id, turmasDisponiveisPorNivel(t.nivel_id || planoNovo.nivel_id)))) {
        alert(mensagemTurmaIndisponivel);
        return;
      }
      isSaving.value = true;

      try {
        const userName = instance.appContext.config.globalProperties.$globalState.userName;
        const turmasCompletas = completarTurmas().map(t => ({
          ...t,
          nivel_id: Number(t.nivel_id) || Number(planoNovo.nivel_id) || null,
          turma_id: Number(t.turma_id) || null
        }));

        // validações
        if (turmasCompletas.some(t => !Number.isInteger(t.turma_id))) {
          alert("Selecione turmas válidas (o identificador da turma está inválido).");
          isSaving.value = false;
          return;
        }
        if (turmasCompletas.some(t => !t.horario)) {
          alert("Selecione dia e horário válidos para todas as turmas.");
          isSaving.value = false;
          return;
        }

        // Data de hoje
        const hoje = new Date();
        const hojeStr = ("0" + hoje.getDate()).slice(-2) + "/" +
          ("0" + (hoje.getMonth() + 1)).slice(-2) + "/" +
          hoje.getFullYear();

        // helper para normalizar qualquer "R$ 1.234,56" -> 1234.56
        const toNumberBR = (v) => {
          if (typeof v === 'number') return v;
          if (v == null || v === '') return 0;
          let s = String(v).trim();
          s = s.replace(/\s/g, '').replace(/^R\$\s?/, ''); // tira R$ e espaços
          s = s.replace(/\./g, '').replace(',', '.');      // milhar e vírgula
          const n = Number(s);
          return Number.isFinite(n) ? n : 0;
        };

        const managedAtiva =
          renovacaoManagedAtiva.value;

        if (managedAtiva) {
          const previewOk =
            await carregarPreviewRenovacaoManaged();

          if (!previewOk) {
            throw new Error(
              'Não foi possível confirmar a prévia financeira da renovação.'
            );
          }
        }

        const valorMensalManaged =
          managedAtiva
            ? normalizarMoedaContratualTexto(
                mensalidadeValorInput.value ||
                mensalidade.valor
              )
            : null;

        const descontoMensalManaged =
          managedAtiva
            ? normalizarPercentualContratualTexto(
                mensalidade.desconto
              )
            : null;

        const regularesManaged =
          managedAtiva
            ? parcelasRegularesRenovacao()
            : [];

        const primeiraRegularManaged =
          regularesManaged[0];

        if (
          managedAtiva &&
          (
            !valorMensalManaged ||
            !descontoMensalManaged ||
            !primeiraRegularManaged ||
            !isBoletoSemantico(
              primeiraRegularManaged.forma_pagamento_id
            ) ||
            !diaVencimentoMensalidadeRenovacao.value
          )
        ) {
          throw new Error(
            'Contexto da mensalidade gerenciada incompleto.'
          );
        }

        const pagamentosParaPayload =
          managedAtiva
            ? mensalidade.pagamentos.filter(
                p =>
                  p.adicional
              )
            : mensalidade.pagamentos;

        const pagamentosRenovacao = pagamentosParaPayload.map((p) => ({
          forma_pagamento_id: p.forma_pagamento_id || null,
          data_vencimento:    p.data_vencimento || null,
          valor:              toNumberBR(p.valor),       // <<< usa o valor recalculado do array
          data_pagamento:     p.data_pagamento || null,
          data_recebimento:   p.data_recebimento || null,
          adicional:          !!p.adicional,
          conta_financeira_id: p.conta_financeira_id ? Number(p.conta_financeira_id) : null,
          banco_numero:       p.banco_numero || null,
          agencia:            p.agencia || null,
          cheque_numero:      p.cheque_numero || null,
          pgt_matricula:      false,
          numero_autorizacao: p.numero_autorizacao || null,
        }));

        // Dados financeiros originais (para histórico) – sempre mantidos inalterados.
        const originalFinanceiro = {
          data_matricula: props.planoAtual.data_matricula,
          valor: props.planoAtual.valor,
          desconto: props.planoAtual.desconto,
          valor_com_desconto: props.planoAtual.valor_com_desconto,
          forma_pagamento_id: props.planoAtual.forma_pagamento_id,
          forma_pagamento: props.planoAtual.forma_pagamento,
          data_vencimento: props.planoAtual.data_vencimento,
          convenio_id: props.planoAtual.convenio_id,
          convenio: props.planoAtual.convenio,
          pagamento_pendente: props.planoAtual.pagamento_pendente === "" ? false : props.planoAtual.pagamento_pendente,
          banco_numero: props.planoAtual.banco_numero,
          agencia: props.planoAtual.agencia,
          cheque_numero: props.planoAtual.cheque_numero,
          conta_financeira_id: props.planoAtual.conta_financeira_id
        };

        // Dados para atualização na matrícula: use os valores preenchidos pelo usuário (editablePlano).
        // Se o usuário não preencher algum campo, o valor permanecerá vazio ou nulo.
        const financeiroUpdate = {
          data_matricula: editablePlano.data_matricula === "" ? null : editablePlano.data_matricula,
          valor: editablePlano.valor === "" ? null : editablePlano.valor,
          desconto: editablePlano.desconto === "" ? null : editablePlano.desconto,
          valor_com_desconto: editablePlano.valor_com_desconto === "" ? null : editablePlano.valor_com_desconto,
          forma_pagamento_id: editablePlano.forma_pagamento_id === "" ? null : editablePlano.forma_pagamento_id,
          forma_pagamento: editablePlano.forma_pagamento === "" ? null : editablePlano.forma_pagamento,
          data_vencimento: editablePlano.data_vencimento === "" ? null : editablePlano.data_vencimento,
          data_pagamento: editablePlano.data_pagamento,
          data_recebimento: editablePlano.data_recebimento || null,
          convenio_id: editablePlano.convenio_id === "" ? null : editablePlano.convenio_id,
          convenio: editablePlano.convenio === "" ? null : editablePlano.convenio,
          pagamento_pendente: editablePlano.pagamento_pendente === "" ? false : editablePlano.pagamento_pendente,
          banco_numero: editablePlano.banco_numero === "" ? null : editablePlano.banco_numero,
          agencia: editablePlano.agencia === "" ? null : editablePlano.agencia,
          cheque_numero: editablePlano.cheque_numero === "" ? null : editablePlano.cheque_numero,
          conta_financeira_id: editablePlano.conta_financeira_id === "" ? null : parseInt(editablePlano.conta_financeira_id),
          observacoes: editablePlano.observacoes || null,
          numero_contrato: props.planoAtual.numero_contrato,
          direito_imagem: editablePlano.direito_imagem === "" ? null : editablePlano.direito_imagem,
          numero_autorizacao: editablePlano.numero_autorizacao || null,
        };

        if (matriculaEstaCancelada()) {
          financeiroUpdate.cancelada = false;
          financeiroUpdate.data_cancelamento = null;
          financeiroUpdate.termino_vigencia_antes_cancelamento = null;
        }

        // --- Observação do benefício (frase pronta para o back-end) ---
        const obsBeneficio =
          beneficio?.value?.observacao
          || (beneficio?.value?.tipo === 'brinde'   && beneficio?.value?.brindeNome
              ? `Brinde de renovação antecipada: ${beneficio.value.brindeNome}`
              : (beneficio?.value?.tipo === 'desconto' && beneficio?.value?.descontoDescricao
                  ? `Brinde de renovação antecipada: Desconto por antecipação - ${beneficio.value.descontoDescricao}`
                  : ''));

        // (opcional) também anexa no campo Observações exibido na tela, sem sobrescrever
        if (obsBeneficio) {
          const sep = mensalidade.observacoes ? ' | ' : ''
          mensalidade.observacoes = (mensalidade.observacoes || '') + sep + obsBeneficio
        }

        // Monta o payload. Para os dados históricos, usamos os valores originais;
        // para atualização da matrícula, usamos os valores preenchidos (financeiroUpdate).
        const payload = {
          // Dados do plano atual e histórico
          id_matricula: props.planoAtual.id,
          numero_contrato: props.planoAtual.numero_contrato,
          aluno: props.planoAtual.aluno,
          aluno_id: props.planoAtual.aluno_id,
          responsavel: props.planoAtual.responsavel,
          responsavel_id: props.planoAtual.responsavel_id,
          categoria_id: props.planoAtual.categoria_id,
          categoria: props.planoAtual.categoria,
          tipo_plano_id: props.planoAtual.tipo_plano_id,
          tipo_plano: props.planoAtual.tipo_plano,
          aulas_semana: props.planoAtual.aulas_semana,
          quantidade_parcelas: props.planoAtual.quantidade_parcelas,
          nivel_id: props.planoAtual.nivel_id,
          nivel: props.planoAtual.nivel,
          inicio_vigencia: props.planoAtual.inicio_vigencia,
          termino_vigencia: props.planoAtual.termino_vigencia,
          data_matricula: originalFinanceiro.data_matricula,
          valor: originalFinanceiro.valor,
          desconto: originalFinanceiro.desconto,
          valor_com_desconto: originalFinanceiro.valor_com_desconto,
          forma_pagamento_id: originalFinanceiro.forma_pagamento_id,
          forma_pagamento: originalFinanceiro.forma_pagamento,
          data_vencimento: originalFinanceiro.data_vencimento,
          data_pagamento: props.planoAtual.data_pagamento,
          data_recebimento: originalFinanceiro.data_recebimento,
          convenio_id: originalFinanceiro.convenio_id,
          convenio: originalFinanceiro.convenio,
          pagamento_pendente: originalFinanceiro.pagamento_pendente,
          banco_numero: originalFinanceiro.banco_numero,
          agencia: originalFinanceiro.agencia,
          cheque_numero: originalFinanceiro.cheque_numero,
          conta_financeira_id: originalFinanceiro.conta_financeira_id,
          valor_mensalidade:
            managedAtiva
              ? valorMensalManaged
              : Number(
                  mensalidade.valor ||
                  0
                ),

          desconto_mensalidade:
            managedAtiva
              ? descontoMensalManaged
              : Number(
                  mensalidade.desconto ||
                  0
                ),
          valor_com_desconto_mensalidade: Number(mensalidade.valor_com_desconto || 0),
          primeiro_vencimento: mensalidade.primeiro_vencimento,                 // já está novo
          quantidade_pagamentos: Number(mensalidade.quantidade_pagamentos || 0),
          valor_total: Number(mensalidade.valor_total || 0),                    // total do novo plano

          // Dados do novo plano e mensalidade
          planoNovo: {
            ...planoNovo,
            turmas: turmasCompletas
          },
          mensalidade: {
            ...mensalidade,
            pagamentos: pagamentosRenovacao,
            // compat: se o benefício for brinde, manter campos antigos
            brinde_id:   beneficio.value?.tipo === 'brinde' ? (beneficio.value?.brindeId || null)   : null,
            brinde_outro: beneficio.value?.tipo === 'brinde' ? (beneficio.value?.brindeNome || null) : null
          },

          beneficio: beneficio.value || null,            // novo objeto para o back-end

          // Usuário que executa a ação
          nome_usuario: userName,

          // Dados para atualização da matrícula
          atualizacao: {
            ...financeiroUpdate
          },

          // Observação especial para gravação em alunos_observacoes (se seu back-end aceitar)
          observacao_beneficio: beneficio.value?.observacao || null,
          // Flag de controle
          isArquivado: isArquivado.value,
          cobrarMatricula: cobrarMatricula.value === true
        };

        if (managedAtiva) {
          const formaId =
            Number(
              primeiraRegularManaged
                .forma_pagamento_id
            );

          const contaId =
            Number(
              primeiraRegularManaged
                .conta_financeira_id
            );

          const dia =
            Number(
              diaVencimentoMensalidadeRenovacao.value
            );

          const todosRegularesCoerentes =
            regularesManaged.length >
              0 &&
            Number.isInteger(
              formaId
            ) &&
            formaId >
              0 &&
            Number.isInteger(
              contaId
            ) &&
            contaId >
              0 &&
            Number.isInteger(
              dia
            ) &&
            dia >= 1 &&
            dia <= 28 &&
            regularesManaged.every(
              p =>
                isBoletoSemantico(
                  p.forma_pagamento_id
                ) &&
                Number(
                  p.forma_pagamento_id
                ) ===
                  formaId &&
                Number(
                  p.conta_financeira_id
                ) ===
                  contaId
            );

          if (!todosRegularesCoerentes) {
            throw new Error(
              'As mensalidades gerenciadas devem usar Boleto e a mesma conta financeira.'
            );
          }

          payload.dia_vencimento_mensalidade =
            dia;

          payload.mensalidade_forma_pagamento_id =
            formaId;

          payload.mensalidade_conta_financeira_id =
            contaId;
        }

        const response = await axios.post('/operacional/matriculas/salvar-renovacao', payload);

        // Pós-venda é efeito acessório. Se o perfil não tiver permissão,
        // a renovação já foi salva e não deve ser desfeita.
        await atualizarPosvendaAposRenovacao({ userName, hojeStr });

        emit('renovarSucesso', response.data);
        cancel();
      } catch (error) {
        console.error("Erro ao renovar matrícula:", error);

        if (renovacaoManagedAtiva.value) {
          alert(
            error?.response?.data?.error ||
            error?.response?.data?.message ||
            error?.message ||
            "Erro ao renovar matrícula. Verifique os logs para mais detalhes."
          );
        } else {
          alert(error.response?.data?.error || "Erro ao renovar matrícula. Verifique os logs para mais detalhes.");
        }
      } finally {
        isSaving.value = false;
      }
    };

    const isArquivado = computed(() => {
      if (!editablePlano.termino_vigencia) return false;
      const hoje = new Date();
      const termino = new Date(editablePlano.termino_vigencia);
      const diffDias = (hoje - termino) / (1000 * 60 * 60 * 24);
      return diffDias > 120;
    });

    const terminoValido = computed(() => !!editablePlano.termino_vigencia &&
      Number.isFinite(new Date(editablePlano.termino_vigencia).getTime()));
    const podeCobrarMatriculaOpcional = computed(() => !isArquivado.value && terminoValido.value);
    const deveCobrarMatricula = computed(() => isArquivado.value ||
      (podeCobrarMatriculaOpcional.value && cobrarMatricula.value === true));
    watch(podeCobrarMatriculaOpcional, disponivel => {
      if (!disponivel) cobrarMatricula.value = false;
    }, { flush: 'sync' });

    const calcularValorComDesconto = () => {
      const valorBase = parseFloat(editablePlano.valor) || 0;
      const desconto = parseFloat(editablePlano.desconto) || 0;
      editablePlano.valor_com_desconto = (valorBase - (valorBase * desconto / 100)).toFixed(2);
    };

    const matriculaValorInput = ref('');
    let valorMatriculaInicializado = false;
    let valorMatriculaEditado = false;

    const valorMatriculaConfigurado = ref(null);
    const carregarValorMatricula = async () => {
      try {
        const { data } = await axios.get('/financeiro/valores', {
          params: { tipo: 'Matrícula', ativo: true, limit: 1000 }
        });
        const valores = Array.isArray(data?.data) ? data.data : [];
        const candidatos = valores.filter(v => v.tipo === 'Matrícula' && v.ativo === true);
        if (candidatos.length !== 1 || Number(data.totalPages || 1) > 1) {
          console.warn('Valor de matrícula ausente ou ambíguo em Financeiro → Valores.');
          return;
        }
        const valor = candidatos[0].valor;
        if (valor == null || String(valor).trim() === '' || !Number.isFinite(Number(valor))) return;
        valorMatriculaConfigurado.value = Number(valor);
      } catch (error) {
        console.error('Erro ao carregar valor da matrícula:', error);
      }
    };
    onMounted(carregarValorMatricula);

    watch(deveCobrarMatricula, ativa => {
      if (ativa) editablePlano.conta_financeira_id = '';
    }, { immediate: true, flush: 'sync' });

    // Configuração é apenas default inicial; inclusive zero manual deve ser preservado.
    watch([deveCobrarMatricula, valorMatriculaConfigurado], ([ativa, valorDefault]) => {
      if (!ativa || valorMatriculaInicializado || valorMatriculaEditado) return;
      if (valorDefault == null || String(valorDefault).trim() === '') return;
      const valor = typeof valorDefault === 'string' && valorDefault.includes(',')
        ? toNumberBR(valorDefault) : Number(valorDefault);
      if (!Number.isFinite(valor)) return;
      editablePlano.valor = valor;
      matriculaValorInput.value = formatBR2(valor);
      valorMatriculaInicializado = true;
      calcularValorComDesconto();
    }, { immediate: true, flush: 'sync' });

    const editarValorMatricula = () => {
      valorMatriculaEditado = true;
      editablePlano.valor = toNumberBR(matriculaValorInput.value);
    };
    const formatarValorMatricula = () => {
      matriculaValorInput.value = formatBR2(editablePlano.valor);
    };
    watch(() => [editablePlano.valor, editablePlano.desconto], calcularValorComDesconto, { flush: 'sync' });

    const atualizarDescontoConvenio = () => {
      const convenioSelecionado = convenios.value.find(c => c.id === editablePlano.convenio_id);
      if (convenioSelecionado) {
        editablePlano.desconto = convenioSelecionado.desconto;
        calcularValorComDesconto();
      }
    };

    function onPagamentoFormaChange(p) {
      if (!p.forma_pagamento_id) {
        p.data_pagamento = null;
        p.data_recebimento = null;
        p.numero_autorizacao = null;
        return;
      }

      const formaId = p.forma_pagamento_id;

      if (
        !p.adicional &&
        isBoletoSemantico(
          formaId
        )
      ) {
        if (!isCheque(formaId)) {
          p.banco_numero = '';
          p.agencia = '';
          p.cheque_numero = '';
        }

        p.numero_autorizacao = null;
        p.data_pagamento = null;
        p.data_recebimento = null;

        const contaAtual =
          p.conta_financeira_id ??
          null;

        const contaExiste =
          contaAtual
            ? contasFinanceiras.value
                .some(
                  c =>
                    String(c.id) ===
                    String(contaAtual)
                )
            : false;

        if (!contaExiste) {
          p.conta_financeira_id =
            null;
        }

        propagarBoletoRegular(
          p
        );

        carregarDiasVencimentoRenovacao();

        return;
      }

      if (!isCheque(formaId)) {
        p.banco_numero = '';
        p.agencia = '';
        p.cheque_numero = '';
      }

      if (!isFormaComAutorizacao(formaId)) {
        p.numero_autorizacao = null;
      }

      if (isAInformar(formaId)) {
        p.conta_financeira_id = null;
        p.data_pagamento = null;
        p.data_recebimento = null;
        p.numero_autorizacao = null;
        return;
      }

      p.data_pagamento = p.data_vencimento || null;

      const contaAtual = p.conta_financeira_id ?? null;
      const contaExiste = contaAtual
        ? contasFinanceiras.value.some(c => String(c.id) === String(contaAtual))
        : false;
      if (!contaExiste) p.conta_financeira_id = null;

      if (isCartaoCreditoParcelado(formaId)) {
        propagarBlocoParceladoParaLinhasVazias(p);

        const bloco = getBlocoParceladoDaParcela(p);

        const comAutorizacao = bloco.find(x => (x.numero_autorizacao || '').trim());
        if (comAutorizacao) {
          p.numero_autorizacao = (comAutorizacao.numero_autorizacao || '').trim();
        }

        const comConta = bloco.find(x => x.conta_financeira_id);
        if (comConta) {
          p.conta_financeira_id = comConta.conta_financeira_id;
        }

        replicarAutorizacaoNoBlocoParcelado(p);
        replicarContaNoBlocoParcelado(p);
        recalcularRecebimentoBlocoParcelado(p);
        return;
      }

      recalcularRecebimentoParcelaMensal(p);
    }

    const valorParcelasAdicionais = computed(() => {
      return mensalidade.pagamentos
        .filter(p => p.adicional && p.valor)
        .reduce((acum, p) => {
          let valorNum = 0;
          if (typeof p.valor === 'string') {
            let v = p.valor.replace(/[^\d,.-]/g, ''); // remove caracteres indesejados
            v = v.replace(/\./g, '').replace(',', '.'); // remove separadores de milhar e troca vírgula por ponto
            valorNum = parseFloat(v);
          } else {
            valorNum = p.valor;
          }
          return acum + (isNaN(valorNum) ? 0 : valorNum);
        }, 0);
    });

    const valorTotalComParcelasAdicionais = computed(() => {
      const totalMensalidade =
        renovacaoManagedAtiva.value &&
        previewRenovacaoManaged.value
          ?.resumo
          ?.total_obrigacoes
          ? Number(
              previewRenovacaoManaged.value
                .resumo
                .total_obrigacoes
            ) || 0
          : parseFloat(
              mensalidade.valor_total
            ) || 0;

      return (
        totalMensalidade +
        valorParcelasAdicionais.value
      );
    });

    const adicionarPagamentoAdicional = () => {
      mensalidade.pagamentos.push({
        forma_pagamento_id: '',
        data_vencimento: '',
        valor: '',
        data_pagamento: '',
        data_recebimento: null,
        conta_financeira_id: null,
        banco_numero: "",
        agencia: "",
        cheque_numero: "",
        numero_autorizacao: null,
        adicional: true
      });
    };

    const desformatarValorAdicional = (pagamento) => {
      if (pagamento.valor) {
        // Remove espaços, "R$", e pontos de milhar
        let unformatted = pagamento.valor
          .replace(/\s/g, '')
          .replace('R$', '')
          .replace(/\./g, '')
          .trim();
        // Aqui, mantemos a vírgula intacta para que o usuário possa usá-la
        pagamento.valor = unformatted;
      }
    };

    // Método para formatar o valor quando o campo perde o foco
    const formatarValorAdicional = (pagamento) => {
      if (pagamento.valor) {
        // Remove espaços e "R$"
        let valorLimpo = pagamento.valor
          .replace(/\s/g, '')
          .replace('R$', '')
          .replace(/\./g, ''); // remove pontos de milhar que o usuário eventualmente digitar
        // Substitui vírgula por ponto para a conversão
        valorLimpo = valorLimpo.replace(',', '.');

        const numero = parseFloat(valorLimpo);
        if (isNaN(numero)) {
          pagamento.valor = '';
          return;
        }
        // Formata o número para o padrão brasileiro, ex: R$ 1.234,56
        const valorFormatado = new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
          minimumFractionDigits: 2
        }).format(numero);
        pagamento.valor = valorFormatado;
      }
    };

    const podeAdicionarPagamento = computed(() => {
      return true;
    });

    const cancel = () => {
      emit('cancelar');
    };

    // carregarFormasPagamento (mantido do teu arquivo)
    const carregarFormasPagamento = async () => {
      try {
        const { data } = await axios.get('/cadastros/formas-pagamento');

        const norm = s => (s ?? '')
          .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
          .trim().toLowerCase();

        const lista = Array.isArray(data?.data) ? data.data : (Array.isArray(data) ? data : []);

        const ordemPersonalizada = {
          'pix': 1,
          'especie': 2,
          'cartao de credito a vista': 3,
          'cartao de credito parcelado': 4,
          'cartao de debito': 5,
          'boleto': 6,
          'transferencia bancaria': 7,
          'cheque': 8,
          'a informar': 9,
        };

        formasPagamento.value = lista
          .filter(fp => norm(fp.nome) !== 'brinde')
          .sort((a, b) => {
            const oa = ordemPersonalizada[norm(a.nome)] ?? 999;
            const ob = ordemPersonalizada[norm(b.nome)] ?? 999;
            if (oa !== ob) return oa - ob;
            return a.nome.localeCompare(b.nome, 'pt-BR');
          });

      } catch (error) {
        console.error("Erro ao carregar formas de pagamento:", error);
      }
    };

    const carregarConvenios = async () => {
      try {
        const response = await axios.get('/cadastros/convenios');
        const data = response.data.data || response.data;
        convenios.value = Array.isArray(data) ? data.filter(c => c.ativo) : [];
      } catch (error) {
        console.error("Erro ao carregar convênios:", error);
      }
    };

    onMounted(async () => {
      // Se a matrícula estiver arquivada, zera os campos financeiros do editablePlano,
      // mas mantém os dados originais em props.planoAtual para o histórico.
      if (isArquivado.value) {
        editablePlano.data_matricula = "";
        editablePlano.forma_pagamento_id = "";
        editablePlano.forma_pagamento = "";
        editablePlano.banco_numero = "";
        editablePlano.agencia = "";
        editablePlano.cheque_numero = "";
        editablePlano.conta_financeira_id = "";
        editablePlano.data_vencimento = "";
        editablePlano.data_pagamento = "";
      }
      const hojeISO = new Date().toISOString().split('T')[0];
      editablePlano.data_matricula = hojeISO;
      editablePlano.data_vencimento = hojeISO;

      await carregarCategorias();
      await carregarNiveis();
      await carregarFormasPagamento();
      await carregarConvenios();
      await carregarContasFinanceiras();

      // ✅ carrega base de turmas depois dos níveis
      await carregarTodasTurmas();

      // Pré-preenche início da vigência do NOVO plano com D+1 do término atual, apenas se a matrícula estiver VIGENTE
      if (!planoNovo.inicio_vigencia && isPlanoVigente() && props.planoAtual?.termino_vigencia) {
        planoNovo.inicio_vigencia = addDaysISO(props.planoAtual.termino_vigencia, 1)
        if (planoNovo.tipo_plano_id) calcularTerminoVigencia()
      }

      await carregarDiasVencimentoRenovacao();

      if (
        renovacaoManagedAtiva.value
      ) {
        atualizarPrimeiroVencimentoManaged();
      }

      // Se renovação antecipada, abrir o modal para escolher benefício
      if (isRenovacaoAntecipada()) {
        showBrindeModal.value = true
      }

    });

    watch(() => props.planoAtual?.termino_vigencia, (novoFim) => {
      if (!planoNovo.inicio_vigencia && novoFim && isPlanoVigente()) {
        planoNovo.inicio_vigencia = addDaysISO(novoFim, 1);
        if (planoNovo.tipo_plano_id) calcularTerminoVigencia();
      }
    });


    // sempre que Data da Matrícula mudar, propaga para Data de Vencimento
    watch(
      () => editablePlano.data_matricula,
      novaDataMatricula => {
        editablePlano.data_vencimento = novaDataMatricula;
      },
      { immediate: true }
    );

    // Recalcula data_recebimento sempre que muda data_pagamento de qualquer parcela
    watch(
      () => mensalidade.pagamentos.map(p => [p.forma_pagamento_id, p.data_pagamento]),
      () => {
        (mensalidade.pagamentos || []).forEach(p => {
          if (
            !p.adicional &&
            isBoletoSemantico(
              p.forma_pagamento_id
            )
          ) {
            p.data_pagamento = null;
            p.data_recebimento = null;
            return;
          }

          if (isCartaoCreditoParcelado(p.forma_pagamento_id)) {
            recalcularRecebimentoBlocoParcelado(p);
          } else {
            recalcularRecebimentoParcelaMensal(p);
          }
        });
      },
      { deep: false }
    );

    watch(
      () => mensalidade.pagamentos.length,
      () => normalizarValoresParcelas()
    );

    // quando aulas_semana mudar, garante slots exatos e nivel_id padrão
    watch(
      () => planoNovo.aulas_semana,
      (novoAulas) => {
        const qtd = Number(novoAulas) || 0;
        if (!qtd) return;
        const nivelPadrao = Number(planoNovo.nivel_id) || null;

        // garante tamanho
        if (planoNovo.turmas.length < qtd) {
          for (let i = planoNovo.turmas.length; i < qtd; i++) {
            planoNovo.turmas.push({
              nivel_id: nivelPadrao,
              turma_id: '',
              id: null,
              dia: "",
              horario: "",
              instrutor: "",
              turma_completa: ""
            });
          }
        } else if (planoNovo.turmas.length > qtd) {
          planoNovo.turmas.splice(qtd);
        }

        // garante nivel_id
        planoNovo.turmas = (planoNovo.turmas || []).map(l => ({
          ...l,
          nivel_id: (l && l.nivel_id != null) ? Number(l.nivel_id) : nivelPadrao
        }));
      }
    );

    return {
      renovacaoManagedAtiva,
      contratoAtualGerenciado,
      diasVencimentoCobranca,
      carregandoDiasVencimentoCobranca,
      erroPoliticaCobranca,
      diaVencimentoMensalidadeRenovacao,
      diaVencimentoHerdadoFrontend,
      onDiaVencimentoRenovacaoChange,
      // turmas
      turmasDisponiveisPorNivel,
      turmaDisponivel,
      onNivelBaseChange,
      onNivelLinhaChange,
      temNivelMisto,

      onPagamentoFormaChange,
      calcularDataPagamento,
      contasFinanceiras,
      adicionarPagamento,
      adicionarPagamentoAdicional,
      adicionarTurma,
      atualizarDescontoConvenio,
      atualizarTurma,
      aulasSemanaOptions,
      cancel,
      categorias,
      completarTurmas,
      convenios,
      calcularTerminoVigencia,
      calcularValorComDesconto,
      calcularValorComDescontoMensalidade,
      calcularValorTotalMensalidade,
      desformatarValorAdicional,
      editablePlano,
      matriculaValorInput,
      editarValorMatricula,
      formatarValorMatricula,
      existeCheque,
      formasPagamento,
      formatarValor,
      formatarValorAdicional,
      formValid,
      globalUtils,
      handleTipoPlanoChange,
      isArquivado,
      cobrarMatricula,
      podeCobrarMatriculaOpcional,
      deveCobrarMatricula,
      isCheque,
      isSaving,
      isEspecie,
      isAInformar,
      mensalidade,
      niveis,
      parcelasOptions,
      planoNovo,
      podeAdicionarPagamento,
      podeAdicionarTurma: computed(() => planoNovo.turmas.length < (parseInt(planoNovo.aulas_semana) || 0)),
      removerPagamento,
      removerTurma,
      renovar,
      tiposPlano,
      turmasDisponiveis,
      valorParcelasAdicionais,
      valorTotalComParcelasAdicionais,
      showBrindeModal,
      beneficio,
      descontoSomenteLeitura,
      onConfirmBeneficio,
      onCancelBeneficio,
      isRenovacaoAntecipada,
      diasAntecedencia,
      isCartao,
      isCartaoCredito,
      isCartaoDebito,

      isFormaComAutorizacao,
      isCartaoCreditoAVista,
      isCartaoCreditoParcelado,
      onNumeroAutorizacaoMensalInput,
      onContaFinanceiraMensalChange,

      mensalidadeValorInput,
      desformatarValorMensalidade,
      formatarValorMensalidade,
      desformatarValorParcela,
      formatarValorParcela,
      isParcelaQuitada,

      totalParcelasCalculado,
      totalParcelasFormatado,
      divergenciaTotal,
      remontarParcelasSemRecalcularTotal,
      diferencaTotal,
      diferencaFormatada,
      diferencaLabel,
      onParcelaValorFocus,
      onParcelaValorBlur,
      toNumberBR,

      previewRenovacaoManaged,
      carregandoPreviewRenovacaoManaged,
      erroPreviewRenovacaoManaged,
      mensagemPreviewProrataRenovacaoManaged,
      primeiroTituloPreviewRenovacaoManaged,
      totalOficialFormatado,

      onEncerrarFinalAnoChange,
    };
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed; top:0; left:0; right:0; bottom:0;
  background: rgba(0,0,0,.5);
  display: flex; align-items: center; justify-content: center;
  z-index: 1050;
}
.modal-container {
  background: #fff; width: 100%; max-width: 75%;
  border-radius: 0; overflow: hidden;
}
.modal-header {
  background: #f5f5f5; padding: .75rem 1rem;
  display: flex; justify-content: space-between; align-items: center;
}
.modal-body {
  padding: 1rem; max-height: 80vh; overflow-y: auto;
}
.modal-footer {
  padding: .75rem 1rem; display: flex; justify-content: flex-end; gap: .5rem;
  background: #f5f5f5;
}
.btn-close {
  background: transparent; border: none; font-size: 1.2rem; cursor: pointer;
}

/* reduz o tamanho dos labels dentro do modal */
.modal-body .form-label {
  font-size: 0.7rem;  /* ajuste até encontrar o tamanho ideal */
  margin-bottom: 0.1rem;  /* antes era .5rem */
}

/* se quiser afinar ainda mais os títulos de seção */
.modal-body .section-title {
  font-size: 0.85rem;
}

  /* Ícone de fechar */
  .close-icon {
    font-size: 1.5rem;
    cursor: pointer;
  }

/* Espaço semelhante ao utilizado no Formulário */
.spacer {
  margin-bottom: 20px;
}

/* Seções e grupos (estilo do formulário) */
.form-section {
  background: white;
  padding: 15px;
  border-radius: 0px;
  border: 1px solid #dee2e6;
  margin-bottom: 1rem;
}

.section-title {
  font-size: 0.9rem;
  font-weight: bold;
  margin-bottom: 10px;
}

.form-group {
  margin-bottom: 10px;
}

.form-group label {
  font-weight: bold;
  margin-bottom: 5px;
  display: block;
}

.required {
  color: red;
}


/* Inputs e selects */
.form-control {
  width: 100%;
  padding: 5px;
  border: 1px solid #ced4da;
  border-radius: 0px;
}

/* Ajustes para botões de ação para turmas e pagamentos */
.turma-item,
.table .btn {
  margin-top: 0px;
}

.add-turma-container {
  display: flex;
  justify-content: flex-end; /* Alinha o botão à direita */
  margin-top: 5px; /* Pequeno espaçamento acima */
}

/* Estilização da chave de alternância */
.toggle-switch {
  position: relative;
  display: inline-flex;
  align-items: center;
  width: 70px;
  height: 25px;
}

/* Esconde o input nativo */
.toggle-input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* Estilização do botão */
/* Container do switch alinhado com os demais campos */
.toggle-switch {
  display: flex;
  align-items: center;
}

.toggle-switch label {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 6px;  /* Ajuste do padding interno */
  min-width: 70px;  /* Largura mínima para acomodar o texto */
  border-radius: 20px;
  font-weight: bold;
}

/* Esconde o input nativo */
.toggle-input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* Estilização do botão */
.toggle-label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  background-color: #007bff; /* Azul para "Não" (Pagamento Quitado) */
  border-radius: 50px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  padding: 4px 16px;
  font-weight: bold;
  color: white;
  font-size: 14px;
  text-align: center;
  position: relative;
}

/* Mudança de cor para "Sim" (Pagamento Pendente) */
.toggle-input:checked + .toggle-label {
  background-color: #dc3545; /* Vermelho para "Sim" */
}

/* Movimentação do botão ao alternar */
.toggle-label:before {
  content: "";
  position: absolute;
  left: 5px;
  width: 18px;
  height: 18px;
  background: white;
  border-radius: 50%;
  transition: transform 0.3s ease;
}

/* Ajusta a posição do botão quando ativado */
.toggle-input:checked + .toggle-label:before {
  transform: translateX(35px);
}

/* Ajuste do texto dentro do botão */
.toggle-label span {
  flex: 1;
  text-align: center;
  font-size: 12px;
  white-space: nowrap;
}

.spacer {
  margin-bottom: 20px;
}

.btn-warning {
  font-size: 12px;
}

</style>